import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import * as stringify from 'json-stable-stringify';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { SupplyService, SupplyType, VastSubTypes, PlayerTypes } from 'app/shared/services/supply.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GridService } from 'app/shared/services/grid.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { CallbacksService } from 'app/shared/services/callbacks.service';
import { CampaignsService } from 'app/shared/services/campaigns.service';
import { GridComponent } from 'app/shared/components/grid/grid.component';
import { forkJoin } from 'rxjs/observable/forkJoin';

@AutoUnsubscribe()
@Component({
  selector: 'new-supply-component',
  templateUrl: './new-supply.component.html',
  styleUrls: ['./new-supply.component.scss'],
})
export class NewSupplyComponent implements OnInit {
  public templatePromise: Promise<string>;
  public template: string;
  public allSections: Array<any>;
  public visibleSections: Array<any>;
  public activeSection: number;
  public editMode: boolean;
  public duplicateMode: boolean;
  public routeParams: any;
  public supplyTypes: Array<any>;
  public subTypes: Array<any>;
  public vastSubTypes: Array<any>;
  public eventsList: Array<any>;
  public partners: Array<any>;
  public newPartner: boolean;
  public supplyData: any;
  public tagData: any;
  public originalData: any;
  public getSupplyResponse: any;
  public supplyTypeName: string;
  public subTypeName: string;
  public domainLists: Array<any>;
  public ipLists: Array<any>;
  public URLsList: Array<any>;
  public targeting: any;
  public partnerIsCedatoXMarketplace: boolean;
  public verifyNetworkForCedatoXLoading: boolean;
  public verifyNetworkForCedatoXConfirmed: boolean;
  public partnerNetworkIdOnFocus: number;
  public showAdvancedOptions: boolean;
  @ViewChild('listAssigned') public assignedDemandGrid: GridComponent;
  public assignedDemandData: Array<any>;
  public assignedDemandDataDisplayed: Array<any>;
  public assignedCampaignDataDisplayed: Array<any>;
  public assignedDemandColumnsSettings: Array<any>;
  public assignedCampaignsColumnsSettings: Array<any>;
  public assignedDemandTabsData: Array<any>;
  public assignedDemandSelectedTab: number;
  public assignedDemandFilters: any;
  public assignedDemandFiltersToGrid: any;
  public assignedEntities: Array<any>;
  public indexedAssignedEntities: any;
  public assignOverrideSettings: any;
  public passbackTimeoutMin: number;
  public passbackTimeoutMax: number;
  public duplicatedPlayerID: number;
  public htmlTag: string;
  public previewUpdateState: boolean;
  public previewBlockMode: boolean;
  public previewPlayerId: string;
  public previewHTML: string;
  public contentDescriptionState: boolean;
  public errorInputs: Array<string>;
  public newListItem: any;
  public cxRevshareConfirm: boolean;
  public playerAPI: any;
  public isLoading: boolean;
  public isLoadingEntities: boolean;
  public isLoadingDomainLists: boolean;
  public isLoadingURLsLists: boolean;
  public isLoadingIPLists: boolean;
  public isLoadingCampaigns: boolean;
  public scriptsOnInit: Array<any>;
  public subscriptions: Array<Subscription>;
  public isCampaignFeatureEnabled: boolean;
  public allowedTag: boolean;
  public unitFormats: any[];
  public tooltipLanguages: any[];
  public tagView: any;
  public contentView: any;
  public context: any;
  public networkDomainOptions: any[];
  public experimentalFeatures = {
    hu: false,
    rv: false,
    dvpaid: false,
    oemPrebidStoreUrlWithQuery: false,
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public httpService: HttpService,
    public supplyService: SupplyService,
    public modalsService: ModalsService,
    public userService: UserService,
    public gridService: GridService,
    public callbacksService: CallbacksService,
    public campaignsService: CampaignsService,
    public ga: GoogleAnalyticsService
  ) {
    this.templatePromise = fetch('/templates/ad-unit.js')
      .then((res) => res.text())
      .then((text) => (this.template = text));
    this.allSections = _.cloneDeep(this.supplyService.sideMenuSections);
    this.visibleSections = [];
    this.routeParams = {};
    this.supplyData = {};
    this.originalData = {};
    this.activeSection = 0;
    this.editMode = false;
    this.duplicateMode = false;
    this.assignedDemandData = [];
    this.assignedDemandDataDisplayed = [];
    this.assignedCampaignDataDisplayed = [];
    this.networkDomainOptions = userService.networkData.network_domains.map(({ domain }) => ({
      value: domain,
      view: domain,
    }));
    this.tagView = {
      selected: 'code',
      options: [
        { value: 'code', label: 'Tag Code' },
        { value: 'params', label: 'Player Params' },
        { value: 'template', label: 'Template Code' },
      ],
    };
    this.contentView = {
      mrssConfigPath: 'playerConfig.playlist.mrss',
      selected: 'video',
      options: [
        { value: 'video', label: 'Video URL' },
        { value: 'mrss', label: 'MRSS URL' },
      ],
    };
    this.context = {};
    this.unitFormats = [
      { value: 'InFeed', view: 'InFeed' },
      { value: 'Persistent', view: 'Persistent' },
      { value: 'InContent', view: 'InContent' },
      { value: 'Corner', view: 'Corner' },
    ];
    this.tooltipLanguages = [
      { value: 'en', view: 'English' },
      { value: 'it', view: 'Italian' },
      { value: 'es', view: 'Spanish' },
    ];
    this.assignedCampaignsColumnsSettings = [
      {
        key: 'b_active',
        label: 'LIVE',
        parseFunction: this.gridService.parseBoolean,
        parseTooltipFunction: this.gridService.parseLiveTooltip,
      },
      { key: 'b_id', label: 'CAMPAIGN_ID', width: 150, filterType: 'INPUT' },
      { key: 'b_name', label: 'CAMPAIGN_NAME', filterType: 'INPUT' },
      {
        key: 'b_running',
        label: 'IS_RUNNING',
        width: 100,
        filterType: 'SELECT',
        parseFunction: this.gridService.parseBoolean,
      },
      { key: 'b_hourly', label: 'HOURLY', width: 100, filterType: 'RANGE' },
      { key: 'b_daily', label: 'DAILY', width: 100, filterType: 'RANGE' },
      {
        key: 'b_start',
        label: 'START_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
      {
        key: 'b_end',
        label: 'END_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
    ];
    this.assignedDemandColumnsSettings = [
      { key: '$$selected', label: 'ASSIGNED', width: 192, resizable: true },
      { key: 'active', label: 'ACTIVE' },
      { key: 'vastId', label: 'DEMAND_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'NAME', filterType: 'INPUT' },
      { key: 'partner', label: 'PARTNER_NAME', filterType: 'SELECT' },
      { key: 'url', label: 'DEMAND_URL', width: 240, filterType: 'INPUT' },
      { key: 'vast_type', label: 'TYPE', filterType: 'SELECT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT_SHORT',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      { key: '$$CPM', label: 'CPM', filterType: 'RANGE', char: '$', align: 'left' },
      { key: '$$defaultCPM', label: 'DEFAULT_CPM' },
      { key: 'domain_list_type', label: 'DOMAIN_LIST', parseFunction: this.gridService.parseListConditionType },
      { key: 'ip_list_type', label: 'IP_LIST', parseFunction: this.gridService.parseListConditionType },
      // {
      //   key: 'is_google_demand',
      //   label: 'GOOGLE_DEMAND',
      //   filterType: 'SELECT',
      //   parseFunction: this.gridService.parseBooleanTooltip,
      //   parseTooltipFunction: this.gridService.parseBooleanTooltip,
      //   featureFlag: 'demand_segmentation',
      // },
      // {
      //   key: 'is_intent_demand',
      //   label: 'INTENT_DEMAND',
      //   filterType: 'SELECT',
      //   parseFunction: this.gridService.parseBooleanTooltip,
      //   parseTooltipFunction: this.gridService.parseBooleanTooltip,
      //   featureFlag: 'demand_segmentation',
      // },
      {
        key: 'limit_assign',
        label: 'LIMITED_ASSIGNMENT',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseBooleanTooltip,
        parseTooltipFunction: this.gridService.parseBooleanTooltip,
        featureFlag: 'limit_assign',
      },
      {
        key: 'premium',
        label: 'FF_PREMIUM_VAST',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseBooleanTooltip,
        parseTooltipFunction: this.gridService.parseBooleanTooltip,
        featureFlag: 'premium_vast',
      },
    ];
    this.assignedDemandTabsData = [
      { title: this.dictionaryService.get('VIEW_ALL') },
      { title: this.dictionaryService.get('VIEW_ELIGIBLE') },
      { title: this.dictionaryService.get('VIEW_INELIGIBLE') },
    ];
    this.assignedDemandSelectedTab = 0;
    this.duplicatedPlayerID = 0;
    this.assignedDemandFilters = { active: [true] };
    this.assignedDemandFiltersToGrid = _.cloneDeep(this.assignedDemandFilters);
    this.assignedEntities = [];
    this.indexedAssignedEntities = {};
    this.assignOverrideSettings = {
      enabled: true,
      state: false,
      label: this.dictionaryService.get('ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_DEMAND'),
    };
    this.passbackTimeoutMin = 15;
    this.passbackTimeoutMax = 999999;
    this.targeting = {
      dma: false,
      location: false,
      browsers: false,
      os: false,
      targetingSizes: false,
      vastDomains: false,
      state: false,
    };
    this.partnerIsCedatoXMarketplace = false;
    this.verifyNetworkForCedatoXLoading = false;
    this.verifyNetworkForCedatoXConfirmed = false;
    this.showAdvancedOptions = false;
    this.htmlTag = '';
    this.previewUpdateState = false;
    this.previewBlockMode = false;
    this.previewPlayerId = '';
    this.previewHTML = '';
    this.errorInputs = [];
    this.newListItem = { label: '+ ' + dictionaryService.get('NEW_LIST'), link: '/list/new' };
    this.cxRevshareConfirm = false;
    this.contentDescriptionState = false;
    this.isLoading = false;
    this.isLoadingEntities = false;
    this.isLoadingCampaigns = false;
    this.isLoadingDomainLists = false;
    this.isLoadingIPLists = false;
    this.scriptsOnInit = Array.from(document.getElementsByTagName('script'));
    this.subscriptions = [];
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'CEDATOX_CONFIRM') {
          this.verifyNetworkForCedatoXConfirmed = response.data;
          if (!this.verifyNetworkForCedatoXConfirmed) {
            this.supplyData.partnerNetworkId = '';
            this.supplyData.partnerNetworkName = '';
          }
        } else if (response.type === 'MODAL_HIDE') {
          if (response.data.component === 'confirm-assign') {
            this.refreshAssignedGrid();
          } else if (response.data.component === 'confirm-limit-assign' && response.data.source === 'cancel') {
            this.assignOverrideSettings.state = true;
          }
        } else if (response.type === 'NETWORK_CHANGE') {
          this.errorInputs = [];
          if (!this.editMode) {
            this.isLoading = true;
            this.assignedDemandData = [];
            this.assignedDemandDataDisplayed = [];
            this.assignedCampaignDataDisplayed = [];
            this.ipLists = [];
            this.domainLists = [];
          }
        } else if (response.type === 'FORM_ERROR_HIDE') {
          _.without(this.errorInputs, response.data);
        } else if (response.type === 'GRID_REFRESH') {
          this.refreshAssignedGrid();
        } else if (response.type === 'GRID_VALUE_CHANGE') {
          this.onAssignedDemandValueChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE_ATTEMPT') {
          this.onAssignedDemandSelectionChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE') {
          this.updateAssignedEntities();
        } else if (response.type === 'CX_REVSHARE_CONFIRM') {
          this.cxRevshareConfirm = true;
          this.save();
        } else if (response.type === 'CONFIRM_LIMIT_ASSIGN') {
          this.changeAssignOverride(false);
        } else if (response.type === 'CONFIGURATION_LOADED') {
          if (response.data && response.data.forcedChange) {
            this.initializeSupplyData(false);
          } else {
            this.router.navigate(['/supply/manage']).then(() => {
              return;
            });
          }
        }
      })
    );
    this.isCampaignFeatureEnabled = this.userService.getFeatureState('manage_campaigns');
    this.allowedTag = true;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.route.params.subscribe((params: any) => {
        if (params.id && params.id !== 'new') {
          this.routeParams.id = params.id;
          this.editMode = true;
          this.initializeSupplyData();
        } else {
          this.parseSupplyData();
        }
      })
    );

    this.subscriptions.push(
      this.route.data.subscribe((data: any) => {
        this.duplicateMode = data.duplicateMode;
        this.setPageTitle();
      })
    );
  }

  ngOnDestroy() {
    this.deleteScripts();
  }

  setPageTitle(): void {
    this.duplicateMode
      ? this.sharedService.setPageTitle('DUPLICATE_SUPPLY', this.supplyData.name)
      : this.editMode
      ? this.sharedService.setPageTitle('EDIT_SUPPLY', this.supplyData.name)
      : this.sharedService.setPageTitle('NEW_SUPPLY');
  }

  initializeSupplyData(changeNetworkAllowed: boolean = true) {
    this.assignedDemandData = [];
    this.assignedDemandDataDisplayed = [];
    this.assignedCampaignDataDisplayed = [];
    this.isLoading = true;
    this.getSupply().subscribe(
      (response: any) => {
        if (!response) {
          this.onError(true);
        } else if (response.code == 501) {
          // it is a custom error. Display the message.
          this.onError(false, response.message);
        } else {
          if (response && response.status.toLowerCase() === 'failed') {
            this.onError(true);
          } else {
            if (response.networkData && response.networkData.networkChanged && changeNetworkAllowed) {
              this.userService.changeNetworkIfNeeded(response);
            } else {
              const supplyType: any = _.find(this.supplyService.supplyTypes, { id: +response.player.player_type });
              const subType: any = _.find(this.supplyService.subTypes, { id: +response.player.sub_type });
              this.getSupplyResponse = response.player;
              this.supplyTypeName = supplyType ? supplyType.name : '';
              this.subTypeName = subType ? 'SUPPLY_SUB_TYPE_' + subType.name.toUpperCase().replace(' ', '_') : '';
              this.parseSupplyData();
            }
          }
        }
      },
      () => {
        this.onError(false);
      }
    );
  }

  initializeEntities(onlyDemands: boolean = false) {
    this.resetTypes();
    this.resetSubTypes();
    this.resetPartners();

    // Set the loading variable to true
    this.isLoadingEntities = true;
    this.isLoadingDomainLists = true;
    this.isLoadingIPLists = true;
    this.isLoadingURLsLists = true;

    this.getDemands().subscribe(
      (response: any) => {
        const allDemands: Array<any> = _.cloneDeep(response);
        let itemInAssignedDemand: any;
        // filter out premium demands
        // if (this.supplyData.type == 2) {
        //   allDemands = _.filter(allDemands, { premium: '0' });
        // }

        allDemands.forEach((demand: any) => {
          itemInAssignedDemand = this.indexedAssignedEntities[+demand.vastId];
          demand.$$selected = itemInAssignedDemand !== undefined;
          demand.vast_type = +demand.vast_type;
          demand.premium = +demand.premium;
          if (itemInAssignedDemand && +demand.vast_type !== 1) {
            demand.$$CPM = itemInAssignedDemand.vast_cpm_on_player;
            demand.$$defaultCPM = itemInAssignedDemand.useDefaultCPM;
          } else {
            demand.$$CPM = demand.vast_cpm_on_player;
            demand.$$defaultCPM = true;
          }
          demand.environment = {
            is_desktop: demand.is_desktop === '1',
            is_mobile_web: demand.is_mobile_web === '1',
            is_mobile_app: demand.is_mobile_app === '1',
            is_ctv: demand.is_ctv === '1',
          };
          demand.limit_assign = demand.limit_assign === '1';
          demand.is_google_demand = demand.is_google_demand === '1';
          demand.is_intent_demand = demand.is_intent_demand === '1';
          if (!this.sharedService.isEmpty(demand.parentNetworkName)) {
            demand.partner = demand.parentNetworkName;
          }
          demand.$$link = '/demand/manage/' + demand.vastId;
        });
        this.assignedDemandData = _.cloneDeep(allDemands);
        if (this.editMode && !onlyDemands) {
          this.updateAssignedEntities();
        }
        this.refreshAssignedGrid();

        this.isLoadingEntities = false;

        forkJoin(this.getDomainLists(), this.getIPLists(), this.getURLsLists()).subscribe(
          ([resDomains, resIP, resURLs]) => {
            this.domainLists = resDomains && _.isArray(resDomains) && resDomains.length ? resDomains : [];
            this.ipLists = resIP && _.isArray(resIP) && resIP.length ? resIP : [];
            this.URLsList = resURLs && _.isArray(resURLs) && resURLs.length ? resURLs : [];

            this.isLoadingIPLists = false;
            this.isLoadingDomainLists = false;
            this.isLoadingURLsLists = false;
          }
        );
      },
      () => {
        this.onError();
      }
    );
  }

  onContentViewChange(selected) {
    this.contentView.selected = selected;
    this.supplyData.contentVideo = '';
    _.unset(this.tagData.config, this.contentView.mrssConfigPath);
  }

  onContentVideoChange() {
    if (this.contentView.selected === 'mrss') {
      if (this.supplyData.contentVideo) {
        const update = _.set({}, this.contentView.mrssConfigPath, this.supplyData.contentVideo);
        this.tagData.config = _.merge(this.tagData.config, update);
      } else {
        _.unset(this.tagData.config, this.contentView.mrssConfigPath);
      }
      this.onTagConfigUpdate();
    }
  }

  // DP-4153: block editing an active legacy Vast supply
  isVastEditDisabled(): boolean {
    return this.editMode && this.supplyData && this.supplyData.type === SupplyType.Vast && !!this.supplyData.active;
  }

  resetTypes() {
    let passFeatureFlag: boolean;
    let passPublisher: boolean;
    this.supplyTypes = [];
    for (let i = 0; i < this.supplyService.supplyTypes.length; i++) {
      passFeatureFlag = this.supplyService.supplyTypes[i].featureFlag
        ? this.userService.getFeatureState(this.supplyService.supplyTypes[i].featureFlag)
        : true;
      passPublisher =
        this.userService.isPublisher() || this.userService.isPublisherNetwork()
          ? this.supplyService.supplyTypes[i].hideFromPublishersNetwork !== true
          : true;
      // DP-4153: legacy Vast supply is deprecated - hide it from the create dropdown
      if (this.supplyService.supplyTypes[i].id === SupplyType.Vast) {
        continue;
      }
      if (this.supplyService.supplyTypes[i].active && passFeatureFlag && passPublisher) {
        this.supplyTypes.push(this.supplyService.supplyTypes[i]);
      }
    }
  }
  resetSubTypes() {
    this.subTypes = _.cloneDeep(this.supplyService.subTypes);
    this.vastSubTypes = _.cloneDeep(this.supplyService.vastSubTypes);
  }

  resetPartners() {
    this.partners = [];
    for (let i = 0; i < this.sharedService.supplyPartners.length; i++) {
      this.partners.push({
        label: this.sharedService.supplyPartners[i].name,
        value: +this.sharedService.supplyPartners[i].partnerId,
      });
    }
  }

  onError(supplyNotFound: boolean = false, customMessage: string = '') {
    let message = '';
    if (customMessage != '') {
      message = customMessage;
    } else {
      message = supplyNotFound ? 'SUPPLY_NOT_FOUND' : 'AN_ERROR_HAS_OCCURRED';
    }
    this.originalData = _.cloneDeep(this.supplyData);
    this.sharedService.showFlashMessage(this.dictionaryService.get(message), 'error');
    this.router.navigate(['/supply/manage']).then(() => {
      return;
    });
  }

  hasChanges(): boolean {
    return !_.isEqual(this.supplyData, this.originalData);
  }

  parseSupplyData() {
    if (this.editMode) {
      this.tagData = this.getSupplyResponse.tag_data || {};
      try {
        this.tagData.config = this.tagData.config ? JSON.parse(this.tagData.config) : null;
        if (_.get(this.tagData.config, this.contentView.mrssConfigPath)) {
          this.contentView.selected = 'mrss';
        }
        if (this.tagData.config && this.tagData.config.eventListener === false) {
          this.tagData.config.eventListener = '';
          this.tagData.config.eventListener_match = '**';
        }
      } catch (err) {
        console.error('tagData config error', err);
        this.tagData.config = null;
      }
      this.getTagCode().then((code) => {
        this.tagData.outOfSync = code !== this.tagData.tag_code;
      });
      this.supplyData = this.parseSupplyResponse();
      if (this.duplicateMode) {
        this.supplyData.name = this.dictionaryService.get('COPY_OF') + this.supplyData.name;
        this.duplicatedPlayerID = this.supplyData.playerId;
        delete this.supplyData.playerId;
        this.supplyData.partnerNetworkId = null;
        this.supplyData.partnerNetworkName = '';
        this.verifyNetworkForCedatoXConfirmed = false;
      }
      if (this.supplyData.type === 0 && this.supplyData.sub_type === 1) {
        const selectedDomain = _.get(this.tagData.config, 'playerConfig.player.servingDomain');
        if (!this.networkDomainOptions.find(({ value }) => value == selectedDomain)) {
          this.networkDomainOptions.push({
            value: selectedDomain,
            view: selectedDomain,
          });
        }
      }
    } else {
      this.supplyData = _.cloneDeep(this.supplyService.supplyModel);
      this.supplyData = _.merge(this.supplyData, this.supplyService.buildExtraParamsDefs());
      this.supplyData.extra_params = stringify(JSON.parse(this.supplyData.extra_params), {
        space: this.sharedService.formatJSONstring,
      });
      this.supplyData.networkDomainName = this.userService.networkData.network_domains[0];
      this.supplyData.supplyPartner = this.getSupplyPlatforms()[0];
      this.supplyData.playerSize = this.supplyService.defaultPlayerSize;
      this.onPlayerSizeChange(this.supplyData.playerSize);
      this.tagData = this.getNewTagData();
    }
    // CedatoX
    if (this.supplyData.type === 2) {
      // If this is the duplication page, and the user doesn't have the relevant feature flag
      if (this.duplicateMode && !this.userService.getFeatureState('duplicate_cedatox')) {
        // Override the 'Navigate away' modal
        this.originalData = _.cloneDeep(this.supplyData);
        // Force navigate to the 'Manage Supply' page
        this.router.navigate(['/supply/manage']).then(() => {
          return;
        });
      } else {
        // Get the partner network data, to determine if it's the CedatoX Marketplace network
        this.subscriptions.push(
          this.httpService
            .post('networks_management/getNetworkData', { networkId: this.supplyData.partnerNetworkId })
            .subscribe((response) => {
              this.partnerIsCedatoXMarketplace = response.cedatox_marketplace === '1';
              if (this.partnerIsCedatoXMarketplace) {
                this.supplyTypeName = 'CEDATOX_MARKETPLACE';
              }
              this.onInitalizationComplete();
            })
        );
      }
    } else {
      this.onInitalizationComplete();
    }
    this.visibleSections = this.buildSideMenuIcons();
  }
  onSubTypeChange($event: any) {
    // put default tags
    if ($event == 1) {
      // put defaults for content unit
      this.tagData = this.getNewTagData();
      this.updateTagCode();
      this.supplyData.asSoonAsAvailable = false;
      this.supplyData.preRoll = true;
      this.supplyData.preRollTime = 6;
      this.supplyData.vastRequestLimit = 1;
    } else {
      // put regular player settings
      this.supplyData.asSoonAsAvailable = this.supplyService.supplyModel.asSoonAsAvailable;
      this.supplyData.preRoll = this.supplyService.supplyModel.preRoll;
      this.supplyData.preRollTime = this.supplyService.supplyModel.preRollTime;
      this.supplyData.vastRequestLimit = this.supplyService.supplyModel.vastRequestLimit;
    }
    this.updateTag();
  }
  /*  onUnitTypeChange() {
      //Things to do if unit type changes.
      this.supplyData.tag_code = _.cloneDeep(_.find(this.supplyService.contentUnitTagDefaults, { id: this.supplyData.tag_type_id })).template;
    }*/

  onAdManagerChange() {
    // Things to do if unit type changes.
    this.tagData.ad_manager = !this.tagData.ad_manager;
    if (!this.tagData.ad_manager) {
      this.tagData.safe_frame = this.supplyService.supplyModel.contentUnitTag.safe_frame;
    }
    this.updateTagCode();
  }

  onTagConfigUpdate() {
    this.tagData.config = {
      ...this.tagData.config,
      playerConfig: {
        ...this.tagData.config.playerConfig,
      },
    };
    this.updateTagCode();
  }

  getTagConfig() {
    const config = _.merge(this.tagData.config, {
      dfpEnabled: this.tagData.ad_manager && !this.tagData.safe_frame,
    });

    function clean(el) {
      return _.transform(el, function (result, value, key) {
        const isCollection = _.isObject(value);
        const cleaned = isCollection ? clean(value) : value;

        if (isCollection && _.isEmpty(cleaned)) {
          return;
        }

        _.isArray(result) ? result.push(cleaned) : (result[key] = cleaned);
      });
    }

    return clean(config);
  }

  getTagCode() {
    return this.templatePromise.then((template) => {
      return this.supplyService.getContentUnitWrapperCode({
        template,
        ...this.getTagConfig(),
      });
    });
  }

  resetTagData() {
    this.tagData = this.getNewTagData();
    this.updateTagCode();
  }

  updateTagCode() {
    this.getTagCode().then((code) => {
      this.tagData.tag_code = code;
      this.tagData.outOfSync = false;
    });
  }

  onTagCodeChange() {
    this.tagData.outOfSync = true;
  }

  onSafeFrameChange($event: any) {
    this.tagData.safe_frame = !this.tagData.safe_frame;
    this.updateTagCode();
  }

  onInitalizationComplete() {
    let currTagType: any;
    switch (this.supplyData.type) {
      // HTML
      case 0:
        currTagType = _.find(this.supplyService.tagTypes, { id: this.supplyData.tagType });
        if (currTagType) {
          this.originalData = _.cloneDeep(this.supplyData);
          this.isLoading = false;
          this.updateTag();
        } else {
          this.onError();
        }
        break;
      // VAST
      case 1:
        this.originalData = _.cloneDeep(this.supplyData);
        this.isLoading = false;
        this.updateTag();
        break;
      // CedatoX
      case 2:
        this.originalData = _.cloneDeep(this.supplyData);
        this.isLoading = false;
        break;
      // Anything else
      default:
        this.onError();
        break;
    }
    if (this.editMode) {
      this.assignedEntities = _.cloneDeep(this.getSupplyResponse.player_vasts);
      this.updateIndexedAssignedEntities();
    }
    if (this.editMode && this.userService.getFeatureState('manage_campaigns')) {
      this.initializeCampaigns().then(() => {
        this.initializeEntities();
      });
    } else {
      this.initializeEntities();
    }
    this.setPageTitle();
    this.cxRevshareConfirm = false;
    if (this.route.snapshot.queryParams.tag === 'true') {
      setTimeout(() => {
        this.goToSection(6, true);
      }, 400);
    }
  }

  updateIndexedAssignedEntities() {
    this.indexedAssignedEntities = {};
    this.assignedEntities.forEach((demand) => {
      this.indexedAssignedEntities[+demand.vastId] = demand;
    });
  }
  getSupply() {
    return this.httpService.post('vdsp_ws/getPlayer', { playerId: this.routeParams.id, onlyActive: true });
  }

  getDemands() {
    const params: any = {};
    if (this.assignedDemandFilters.active.length === 1) {
      params.activeDemands = this.assignedDemandFilters.active[0] ? 1 : 0;
    }
    return this.httpService.post('vdsp_ws/getDemands', params);
  }

  getDomainLists() {
    return this.httpService.post('restriction_lists/getDomainListsUI');
  }

  getIPLists() {
    return this.httpService.post('restriction_lists/getIPListsUI');
  }

  getURLsLists() {
    return this.httpService.post('restriction_lists/getURLsListsUI');
  }

  updateAssignedEntities(specificItem: any = null) {
    const assignedEntities: Array<any> = _.cloneDeep(this.assignedEntities);
    let index: number;
    let state: boolean;
    let currItem: any;
    let defaultCPM: boolean;
    if (specificItem !== null) {
      index = _.findIndex(assignedEntities, { vastId: specificItem.vastId });
      if (index === -1) {
        assignedEntities.push(specificItem);
      } else {
        specificItem.$$selected ? (assignedEntities[index] = specificItem) : assignedEntities.splice(index, 1);
      }
    } else {
      if (this.assignedDemandGrid) {
        if (this.assignedDemandGrid.displayedData.length > 0) {
          this.assignedDemandGrid.displayedData.forEach((item: any) => {
            index = _.findIndex(assignedEntities, { vastId: item.vastId });
            currItem = _.find(this.assignedDemandData, { vastId: item.vastId });
            state = item.$$selected;
            if (state && index === -1) {
              assignedEntities.push(item);
              if (currItem) {
                currItem.$$selected = state;
              }
            } else if (!state && index > -1) {
              assignedEntities.splice(index, 1);
              if (currItem) {
                currItem.$$selected = state;
              }
            }
          });
        }
      }
    }
    this.assignedEntities = [];
    this.indexedAssignedEntities = {};
    assignedEntities.forEach((item: any) => {
      defaultCPM = item.$$defaultCPM === undefined ? item.useDefaultCPM : item.$$defaultCPM;
      const itemToAdd = {
        vastId: item.vastId,
        is_active_on_player: 1,
        vast_cpm_on_player: item.$$CPM ? item.$$CPM : item.vast_cpm_on_player,
        useDefaultCPM: defaultCPM,
        premium: item.premium,
        $$defaultCPM: defaultCPM,
        $$selected: item.$$selected,
      };
      this.assignedEntities.push(itemToAdd);
      this.indexedAssignedEntities[+item.vastId] = itemToAdd;
    });
  }

  refreshAssignedGrid() {
    this.onAssignedDemandTabSelected(this.assignedDemandSelectedTab);
  }

  onAssignedDemandTabSelected(id: number) {
    const assignedDemandData: Array<any> = _.cloneDeep(this.assignedDemandData);
    const costValue: number = this.supplyData.costValue;
    let eligible: Array<any>;
    let ineligible: Array<any>;

    if (this.supplyData.type === 2 && !this.userService.isAllowedCx2Cx()) {
      _.remove(assignedDemandData, (demand: any) => {
        return +demand.vast_type === 1;
      });
    }

    // If we're in a 'Fixed CPM' cost type
    if (this.supplyService.isFixedCPM(this.supplyData.costType)) {
      // Filter the eligible/ineligible data by cost-value
      eligible = _.filter(assignedDemandData, function (demand: any) {
        return parseFloat(demand.vast_cpm_on_player) >= costValue || +demand.vast_type === 1;
      });
      ineligible = _.filter(assignedDemandData, function (demand: any) {
        return parseFloat(demand.vast_cpm_on_player) < costValue;
      });
    } else {
      // All are eligible, none are ineligible
      eligible = _.cloneDeep(assignedDemandData);
      ineligible = [];
    }
    // Display the relevant data
    switch (id) {
      case 0:
        this.assignedDemandDataDisplayed = _.cloneDeep(assignedDemandData);
        break;
      case 1:
        this.assignedDemandDataDisplayed = _.cloneDeep(eligible);
        break;
      case 2:
        this.assignedDemandDataDisplayed = _.cloneDeep(ineligible);
        break;
    }
    // "Bad" cells (low CPM warning)
    this.assignedDemandDataDisplayed.forEach((item: any) => {
      item.$$badSelection =
        item.$$selected &&
        this.supplyService.isFixedCPM(this.supplyData.costType) &&
        parseFloat(item.$$CPM) < this.supplyData.costValue;
    });
    // Update the tabs' titles and the selected tab ID
    this.assignedDemandTabsData = [
      { title: this.dictionaryService.get('VIEW_ALL') + ' (' + assignedDemandData.length + ')' },
      { title: this.dictionaryService.get('VIEW_ELIGIBLE') + ' (' + eligible.length + ')' },
      {
        title:
          this.dictionaryService.get('VIEW_INELIGIBLE') + " <span class='badText'>(" + ineligible.length + ')</span>',
      },
    ];
    this.assignedDemandSelectedTab = id;
  }

  onAssignedDemandValueChange($event: any) {
    const displayedData = _.cloneDeep(this.assignedDemandDataDisplayed);
    const dataItem: any = _.cloneDeep($event.dataItem);
    let shouldUpdateGrid = false;
    switch ($event.changedValue) {
      case '$$defaultCPM':
        dataItem.$$defaultCPM = !dataItem.$$defaultCPM;
        if (dataItem.$$defaultCPM) {
          dataItem.$$CPM = parseFloat(dataItem.CPM);
          dataItem.vast_cpm_on_player = dataItem.$$CPM;
        }
        shouldUpdateGrid = true;
        break;
      case '$$CPM':
        dataItem.$$CPM = parseFloat(_.find($event.item, { key: '$$CPM' }).value);
        dataItem.vast_cpm_on_player = dataItem.$$CPM;
        break;
    }
    this.assignedDemandData[_.findIndex(this.assignedDemandData, { vastId: dataItem.vastId })] = dataItem;
    this.updateAssignedEntities(dataItem);
    if (shouldUpdateGrid) {
      setTimeout(() => {
        displayedData[_.findIndex(displayedData, { $$itemId: dataItem.$$itemId })] = dataItem;
        this.assignedDemandDataDisplayed = displayedData;
      }, 100);
    }
  }

  onAssignedDemandSelectionChange(allSelectedState: boolean) {
    const title: string = allSelectedState ? 'SELECT_ALL' : 'UNSELECT_ALL';
    this.modalsService.showModal({
      title: this.dictionaryService.get(title),
      component: 'confirm-assign',
      data: { state: allSelectedState, type: 'demand' },
    });
  }

  onAssignedDemandFilterChange($event: any) {
    if (!_.isEqual($event.active, this.assignedDemandFilters.active)) {
      this.assignedDemandFilters = $event;
      this.initializeEntities(true);
    }
  }

  onAssignOverrideChange($event: any) {
    let amount: number;
    if ($event) {
      this.changeAssignOverride($event);
    } else {
      amount = _.filter(this.assignedDemandData, (demand: any) => {
        if (demand.limit_assign === '1') {
          return _.find(this.assignedEntities, { vastId: demand.vastId });
        }
      }).length;
      if (amount > 0) {
        this.modalsService.showModal({
          title: this.dictionaryService.get('ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_DEMAND'),
          component: 'confirm-limit-assign',
          data: {
            amount: amount,
            type: 'supply',
          },
        });
      } else {
        this.changeAssignOverride($event);
      }
    }
  }

  changeAssignOverride(state: boolean) {
    this.assignOverrideSettings.state = state;
    if (!state) {
      this.assignedEntities.forEach((assigned: any) => {
        const demand: any = _.find(this.assignedDemandData, { vastId: assigned.vastId });
        if (demand.limit_assign === '1') {
          demand.$$selected = false;
          this.updateAssignedEntities(demand);
        }
      });
    }
    this.refreshAssignedGrid();
  }

  parseSupplyResponse() {
    const supplyResponse: any = {};
    let tagSchemaSelected: any;
    let tagSchema: any;
    let partnerId: number;
    const passbackCode: string = !this.sharedService.isEmpty(this.getSupplyResponse.passback_code)
      ? JSON.parse(this.getSupplyResponse.passback_code).string
      : '';
    let targeting =
      this.getSupplyResponse.targeting && this.getSupplyResponse.targeting.length
        ? this.getSupplyResponse.targeting[0]
        : {};
    let currTargetingItem: any;
    let currTargetingLimits: any;
    let currCappingItem: any;
    const tagData: any = this.getSupplyResponse.tag_data;
    const callbacks: Array<any> = [];
    let currEvent: any;
    let currCallback: any;
    const extraParamsSectionItem: any = _.find(this.allSections, { value: 'extraParams' });
    // Settings
    supplyResponse.playerId = this.sharedService.parseNumeric(this.getSupplyResponse.playerId);
    supplyResponse.name = this.getSupplyResponse.player_name;
    supplyResponse.type = this.sharedService.parseNumeric(this.getSupplyResponse.player_type);
    supplyResponse.sub_type = this.sharedService.parseNumeric(this.getSupplyResponse.sub_type);
    supplyResponse.networkId = this.sharedService.parseNumeric(this.getSupplyResponse.networkId);
    supplyResponse.active = this.getSupplyResponse.is_active === '1';
    supplyResponse.limitAssign = this.getSupplyResponse.limit_assign === '1';
    supplyResponse.hb = this.getSupplyResponse.hb === '1';
    supplyResponse.is_desktop = this.getSupplyResponse.is_desktop === '1';
    supplyResponse.is_mobile_web = this.getSupplyResponse.is_mobile_web === '1';
    supplyResponse.is_mobile_app = this.getSupplyResponse.is_mobile_app === '1';
    supplyResponse.is_ctv = this.getSupplyResponse.is_ctv === '1';
    supplyResponse.isMobile = supplyResponse.is_mobile_web || supplyResponse.is_mobile_app;
    supplyResponse.partnerId = this.sharedService.parseNumeric(this.getSupplyResponse.partnerId);
    supplyResponse.partnerName = this.getSupplyResponse.partnerName;
    if (!this.sharedService.isEmpty(this.getSupplyResponse.affiliate_network_name)) {
      supplyResponse.partnerName = this.getSupplyResponse.affiliate_network_name;
    }
    supplyResponse.floorCPMPrice = this.sharedService.parseNumeric(this.getSupplyResponse.floor_cpm_price);
    supplyResponse.costType = this.sharedService.parseNumeric(this.getSupplyResponse.cost_type);
    supplyResponse.costValue = this.sharedService.parseNumeric(this.getSupplyResponse.cost_value);
    supplyResponse.allowSound = this.getSupplyResponse.isMuted === '0';
    supplyResponse.rotation = this.getSupplyResponse.rotate === '1';
    supplyResponse.rotationNumber = this.sharedService.parseNumeric(this.getSupplyResponse.rotate_number);
    supplyResponse.autoPlay = this.getSupplyResponse.autoplay === '1';
    supplyResponse.controlBar = this.getSupplyResponse.controlbar === '1';
    supplyResponse.cedatoXVastId = this.sharedService.parseNumeric(this.getSupplyResponse.cedatoXVastId);
    supplyResponse.partnerNetworkId = this.sharedService.parseNumeric(this.getSupplyResponse.affiliate_network_id);
    supplyResponse.partnerNetworkName = this.getSupplyResponse.affiliate_network_name;
    supplyResponse.pm_value = this.getSupplyResponse.pm_value;
    this.verifyNetworkForCedatoXConfirmed = true;
    supplyResponse.extra_params = this.sharedService.parseBoolean(this.getSupplyResponse.extra_params_enabled)
      ? stringify(JSON.parse(this.getSupplyResponse.extra_params), { space: this.sharedService.formatJSONstring })
      : stringify(JSON.parse(this.supplyService.extraParamsDefaultValue.json), {
          space: this.sharedService.formatJSONstring,
        });
    supplyResponse.extra_params_url = this.sharedService.parseBoolean(this.getSupplyResponse.extra_params_enabled)
      ? this.getSupplyResponse.extra_params_url
      : this.supplyService.extraParamsDefaultValue.url;
    supplyResponse.extra_params_enabled = this.sharedService.parseBoolean(this.getSupplyResponse.extra_params_enabled);

    this.getExperimentalFeatures(supplyResponse.extra_params);

    if (extraParamsSectionItem) {
      extraParamsSectionItem.onIf =
        supplyResponse.extra_params_enabled &&
        (stringify(JSON.parse(supplyResponse.extra_params)) !==
          stringify(JSON.parse(this.supplyService.extraParamsDefaultValue.json)) ||
          supplyResponse.extra_params_url !== this.supplyService.extraParamsDefaultValue.url);
    }
    // Content
    supplyResponse.contentImage = this.getSupplyResponse.loader_image_url;
    supplyResponse.contentVideo = this.getSupplyResponse.content_url;
    supplyResponse.shuffleVideoPlaylist = this.getSupplyResponse.content_url_shuffle === '1';
    supplyResponse.videoDescription = this.getSupplyResponse.content_video_desc;
    supplyResponse.videoKeywords = this.getSupplyResponse.content_video_keywords;
    supplyResponse.videoTitle = this.getSupplyResponse.content_video_title;
    supplyResponse.asSoonAsAvailable =
      this.getSupplyResponse.preroll === '0' &&
      this.getSupplyResponse.midroll === '0' &&
      this.getSupplyResponse.content_play_full === '0';
    supplyResponse.preRoll = this.getSupplyResponse.preroll === '1';
    supplyResponse.preRollTime = this.sharedService.parseNumeric(this.getSupplyResponse.preroll_time);
    supplyResponse.midRoll = this.getSupplyResponse.midroll === '1';
    supplyResponse.midRollAllowedAdDelay = this.sharedService.parseNumeric(
      this.getSupplyResponse.midroll_allowed_ad_delay
    );
    supplyResponse.midRollFirstAdTime = this.sharedService.parseNumeric(this.getSupplyResponse.midroll_first_ad_time);
    supplyResponse.midRollInterval = this.sharedService.parseNumeric(this.getSupplyResponse.midroll_interval);
    supplyResponse.postRoll = this.getSupplyResponse.content_play_full === '1';
    supplyResponse.loopContent = this.getSupplyResponse.content_loop === '1';
    supplyResponse.contentControlBar = this.getSupplyResponse.content_control_bar === '1';
    supplyResponse.clickURL = this.getSupplyResponse.content_url_click;
    // Restrictions
    supplyResponse.custom_mvr = this.getSupplyResponse.custom_mvr !== 0;
    if (!supplyResponse.custom_mvr) {
      supplyResponse.vastRequestLimit = this.sharedService.parseNumeric(this.getSupplyResponse.user_mvr);
      supplyResponse.custom_vastRequestLimit = this.supplyService.supplyModel.custom_vastRequestLimit;
    } else {
      supplyResponse.custom_vastRequestLimit = this.sharedService.parseNumeric(this.getSupplyResponse.user_mvr);
      supplyResponse.vastRequestLimit = this.supplyService.supplyModel.vastRequestLimit;
    }
    supplyResponse.maxAdRequestsPerOpportunity =
      this.sharedService.parseNumeric(this.getSupplyResponse.max_total_vast_requests) > 0;
    supplyResponse.maxTotalVastRequests = this.sharedService.parseNumeric(
      this.getSupplyResponse.max_total_vast_requests
    );
    supplyResponse.domainListType = this.sharedService.parseNumeric(this.getSupplyResponse.domain_list_type);
    supplyResponse.domainLists = this.getSupplyResponse.domain_lists;
    supplyResponse.urlLists = this.getSupplyResponse.url_lists;
    supplyResponse.urlListType = this.sharedService.parseNumeric(this.getSupplyResponse.url_list_type);
    supplyResponse.ipListType = this.sharedService.parseNumeric(this.getSupplyResponse.ip_list_type);
    supplyResponse.ipLists = this.getSupplyResponse.ip_lists;
    supplyResponse.cxTrafficSourceAllowedHTML = this.getSupplyResponse.cx_traffic_source_allowed_html === '1';
    supplyResponse.cxTrafficSourceAllowedVAST = this.getSupplyResponse.cx_traffic_source_allowed_vast === '1';
    supplyResponse.player_capping = [];
    for (let i = 1; i <= 2; i++) {
      currCappingItem = _.find(this.getSupplyResponse.player_capping, { cappingType: i.toString() });
      supplyResponse.player_capping.push({
        active: false,
        cappingType: i,
        cappingValue: null,
        paceOption: 1,
        playerId: supplyResponse.playerId,
      });
      if (currCappingItem) {
        supplyResponse.player_capping[i - 1].id = parseInt(currCappingItem.id);
        supplyResponse.player_capping[i - 1].active = true;
        supplyResponse.player_capping[i - 1].cappingValue = this.sharedService.toLocaleString(
          currCappingItem.cappingValue
        );
        supplyResponse.player_capping[i - 1].paceOption = parseInt(currCappingItem.paceOption);
      }
    }
    // Callbacks
    this.getSupplyResponse.callbacks.forEach((callback: any) => {
      currEvent = _.find(this.supplyService.eventsList, (evt: any) => {
        return evt.eventId === parseInt(callback.eventId) && evt.typeId === parseInt(callback.typeId);
      });
      if (currEvent) {
        currCallback = {
          callbackId: parseInt(callback.callbackId),
          url: callback.url,
          event: currEvent,
          rate: parseInt(callback.rate),
        };
        if (this.duplicateMode) {
          delete currCallback.callbackId;
        }
        callbacks.push(currCallback);
      }
    });
    supplyResponse.callbacks = callbacks;
    // Targeting
    supplyResponse.targeting = {
      dma: { type: 0, list: [] },
      location: { type: 0, list: [] },
      browsers: { type: 0, list: [] },
      os: { type: 0, list: [] },
      targetingSizes: { type: 0, list: [] },
      envs: { type: 0, list: [] },
      vast_domains: { type: 0, list: [] },
      state: { type: 0, list: [] },
    };
    if (targeting === undefined) {
      targeting = _.cloneDeep(supplyResponse.targeting);
    }
    // Targeting
    if (supplyResponse.type === 2 && targeting.targeting_id) {
      supplyResponse.targeting.targeting_id = parseInt(targeting.targeting_id);
      supplyResponse.targeting.location.type = parseInt(targeting.country_codes_oper);
      supplyResponse.targeting.browsers.type = parseInt(targeting.browsers_oper);
      supplyResponse.targeting.os.type = parseInt(targeting.os_oper);
      supplyResponse.targeting.targetingSizes.type = parseInt(targeting.sizes_oper);
      supplyResponse.targeting.envs.type = parseInt(targeting.envs_oper);
      supplyResponse.targeting.vast_domains.type = parseInt(targeting.vast_domains_oper);
      supplyResponse.targeting.app_bundle_oper = parseInt(targeting.app_bundle_oper);
      supplyResponse.targeting.detected_domain_oper = parseInt(targeting.detected_domain_oper);
      supplyResponse.targeting.dma.type = +targeting.dma_oper;
      supplyResponse.targeting.state.type = +targeting.state_oper;
      targeting.country_codes =
        typeof targeting.country_codes === 'string' ? targeting.country_codes.split(',') : targeting.country_codes;
      targeting.browsers = typeof targeting.browsers === 'string' ? targeting.browsers.split(',') : targeting.browsers;
      targeting.os = typeof targeting.os === 'string' ? targeting.os.split(',') : targeting.os;
      targeting.sizes = typeof targeting.sizes === 'string' ? targeting.sizes.split(',') : targeting.sizes;
      targeting.sizes_ui = typeof targeting.sizes_ui === 'string' ? targeting.sizes_ui.split('|') : targeting.sizes_ui;
      targeting.dma = typeof targeting.dma === 'string' ? targeting.dma.split(',') : targeting.dma;
      targeting.state = typeof targeting.state === 'string' ? targeting.state.split(',') : targeting.state;
      for (let i = 0; i < targeting.country_codes.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.countries, function (o) {
          return o.iso === targeting.country_codes[i];
        });
        if (currTargetingItem) {
          supplyResponse.targeting.location.list.push(currTargetingItem);
        }
      }
      for (let i = 0; i < targeting.browsers.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.browsers, function (o) {
          const targetingBrowsers: any = targeting.browsers[i].split(':');
          return targetingBrowsers && targetingBrowsers.length ? o.code === targeting.browsers[i].split(':')[0] : false;
        });
        if (currTargetingItem) {
          currTargetingLimits = targeting.browsers[i].split(':')[1].split('-');
          if (currTargetingLimits && currTargetingLimits.length) {
            currTargetingItem.from =
              currTargetingLimits[0] !== 'latest' ? currTargetingLimits[0] : this.dictionaryService.get('LATEST');
            currTargetingItem.to =
              currTargetingLimits[1] !== 'latest' ? currTargetingLimits[1] : this.dictionaryService.get('LATEST');
            supplyResponse.targeting.browsers.list.push(currTargetingItem);
          }
        }
      }
      for (let i = 0; i < targeting.os.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.os, function (o) {
          const targetingOS: any = targeting.os[i].split(':');
          return targetingOS && targetingOS.length ? o.code === targeting.os[i].split(':')[0] : false;
        });
        if (currTargetingItem) {
          currTargetingLimits = targeting.os[i].split(':')[1].split('-');
          if (currTargetingLimits && currTargetingLimits.length) {
            currTargetingItem.from =
              currTargetingLimits[0] !== 'latest' ? currTargetingLimits[0] : this.dictionaryService.get('LATEST');
            currTargetingItem.to =
              currTargetingLimits[1] !== 'latest' ? currTargetingLimits[1] : this.dictionaryService.get('LATEST');
            supplyResponse.targeting.os.list.push(currTargetingItem);
          }
        }
      }
      for (let i = 0; i < targeting.sizes.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.targetingSizes, function (o) {
          return o.targeting_playerSize_id === targeting.sizes[i];
        });
        if (currTargetingItem) {
          supplyResponse.targeting.targetingSizes.list.push(currTargetingItem);
        }
      }
      for (let i = 0; i < targeting.sizes_ui.length; i++) {
        if (!this.sharedService.isEmpty(targeting.sizes_ui[i])) {
          targeting.sizes_ui[i] = JSON.parse(targeting.sizes_ui[i]);
          supplyResponse.targeting.targetingSizes.list.push({
            name: targeting.sizes_ui[i].n,
            custom: true,
            operator: targeting.sizes_ui[i].o,
            width: parseInt(targeting.sizes_ui[i].w),
            height: parseInt(targeting.sizes_ui[i].h),
          });
        }
      }
      for (let i = 0; i < targeting.envs.length; i++) {
        supplyResponse.targeting.envs.list.push(targeting.envs[i]);
      }
      for (let i = 0; i < targeting.vast_domains.length; i++) {
        if (!this.sharedService.isEmpty(targeting.vast_domains[i])) {
          supplyResponse.targeting.vast_domains.list.push(targeting.vast_domains[i]);
        }
      }
      if (targeting.dma && targeting.dma.length) {
        for (let i = 0; i < targeting.dma.length; i++) {
          if (!this.sharedService.isEmpty(targeting.dma[i])) {
            const targetingItem = _.find(this.sharedService.targetingLookups.DMAs, { dma_id: targeting.dma[i] });
            if (targetingItem) {
              supplyResponse.targeting.dma.list.push(targetingItem);
            }
          }
        }
      }
      if (targeting.state && targeting.state.length) {
        for (let i = 0; i < targeting.state.length; i++) {
          if (!this.sharedService.isEmpty(targeting.state[i])) {
            const targetingItem = _.find(this.sharedService.targetingLookups.state, { iso: targeting.state[i] });
            if (targetingItem) {
              supplyResponse.targeting.state.list.push(targetingItem);
            }
          }
        }
      }
      this.targeting.location = supplyResponse.targeting.location.type !== 0;
      this.targeting.browsers = supplyResponse.targeting.browsers.type !== 0;
      this.targeting.os = supplyResponse.targeting.os.type !== 0;
      this.targeting.targetingSizes = supplyResponse.targeting.targetingSizes.type !== 0;
      this.targeting.vastDomains = supplyResponse.targeting.vast_domains.type !== 0;
      this.targeting.dma = supplyResponse.targeting.dma.type !== 0;
      this.targeting.state = supplyResponse.targeting.state.list.length !== 0;
    }
    if (supplyResponse.type === 1 && targeting.targeting_id) {
      supplyResponse.targeting.targeting_id = parseInt(targeting.targeting_id);
      supplyResponse.targeting.app_bundle_oper = parseInt(targeting.app_bundle_oper);
      supplyResponse.targeting.detected_domain_oper = parseInt(targeting.detected_domain_oper);
    }
    // Special Vendor BlackList handling
    if ([0, 1].includes(supplyResponse.type) && targeting.targeting_id) {
      supplyResponse.targeting.vast_domains.type = parseInt(targeting.vast_domains_oper);
      targeting.vast_domains =
        typeof targeting.vast_domains === 'string' ? targeting.vast_domains.split(',') : targeting.vast_domains;
      for (let i = 0; i < targeting.vast_domains.length; i++) {
        supplyResponse.targeting.vast_domains.list.push(targeting.vast_domains[i]);
      }
      this.targeting.vastDomains = supplyResponse.targeting.vast_domains.type !== 0;
    }

    // Tag
    if (supplyResponse.type !== 2) {
      // Schema
      if (this.getSupplyResponse.tag_schemas.length > 0) {
        if (this.getSupplyResponse.tag_schema_selected !== null) {
          tagSchemaSelected = _.find(this.getSupplyResponse.tag_schemas, {
            partnerId: this.getSupplyResponse.tag_schema_selected,
          });
        }
        if (tagSchemaSelected === undefined) {
          tagSchemaSelected = this.getSupplyResponse.tag_schemas[0];
        }
      } else {
        tagSchemaSelected = {};
      }
      tagSchema = tagSchemaSelected.id
        ? JSON.parse(tagSchemaSelected.tagSchema)
        : this.supplyService.supplyModel.tagSchemaSelected;
      partnerId = tagSchemaSelected.id ? parseInt(tagSchemaSelected.partnerId) : 0;
      supplyResponse.tagSchemas = this.getSupplyResponse.tag_schemas;
      // Properties
      supplyResponse.tagType = 0;
      supplyResponse.supplyPartner = _.find(this.supplyService.supplyPartners, function (o) {
        return parseInt(o.val) === partnerId;
      });
      supplyResponse.playerSize = _.find(this.supplyService.playerSizes, function (o) {
        return o.val === tagSchema.tagSizeSelected.val;
      });
      supplyResponse.width = tagSchema.tagSize.width;
      supplyResponse.height = tagSchema.tagSize.height;
      supplyResponse.subId = tagSchema.tagSubId;
      supplyResponse.secure = tagSchema.tagSecure;
      supplyResponse.mobileApp = tagSchema.tagMobileApp;
      supplyResponse.passback = this.getSupplyResponse.passback === '1';
      supplyResponse.passbackTimeout = this.sharedService.parseNumeric(this.getSupplyResponse.passback_timeout);
      supplyResponse.passbackCode = passbackCode;
      if (tagSchema.tag_domain_selected) {
        if (parseInt(tagSchema.tag_domain_selected.domainId) !== 0) {
          supplyResponse.networkDomainName = _.find(this.userService.networkData.network_domains, {
            domainId: parseInt(tagSchema.tag_domain_selected.domainId),
          });
        }
      }
      if (
        this.sharedService.isEmpty(supplyResponse.networkDomainName) &&
        this.userService.networkData.network_domains &&
        this.userService.networkData.network_domains.length > 0
      ) {
        supplyResponse.networkDomainName = this.userService.networkData.network_domains[0];
      }
      supplyResponse.vpaidTypeSelected = tagSchema.vpaidTypeSelected;
      supplyResponse.tagSchemaSelected = tagSchemaSelected;
      // Native tag units
      if (tagData) {
        if (supplyResponse.sub_type === 0) {
          if (parseInt(tagData.tag_type) !== 0) {
            supplyResponse.tagType = this.sharedService.parseNumeric(tagData.tag_type);
            supplyResponse.domain = tagData.domain;
            supplyResponse.secure = tagData.secure === '1';
            if (!this.sharedService.isEmpty(tagData.servingDomain)) {
              supplyResponse.networkDomainName = _.find(this.userService.networkData.network_domains, {
                domain: tagData.servingDomain,
              })
                ? _.find(this.userService.networkData.network_domains, { domain: tagData.servingDomain })
                : this.userService.networkData.network_domains[0];
            } else {
              supplyResponse.networkDomainName = this.userService.networkData.network_domains[0];
            }
            supplyResponse.sizeType = this.sharedService.parseNumeric(tagData.size_type);
            supplyResponse.width = tagData.width > 0 ? tagData.width : this.supplyService.supplyModel.width;
            supplyResponse.height = tagData.height > 0 ? tagData.height : this.supplyService.supplyModel.height;
            supplyResponse.ratio =
              tagData.ratio > 0
                ? this.sharedService.parseNumeric(tagData.ratio)
                : this.sharedService.parseNumeric(this.supplyService.supplyModel.ratio);
            supplyResponse.cornerWidth = supplyResponse.width;
            if (supplyResponse.tagType === 7 || supplyResponse.tagType === 8) {
              if (supplyResponse.sizeType === 0) {
                supplyResponse.width = this.supplyService.supplyModel.width;
                supplyResponse.height = this.supplyService.supplyModel.height;
              } else if (supplyResponse.sizeType === 1) {
                supplyResponse.ratio = this.sharedService.parseNumeric(this.supplyService.supplyModel.ratio);
                supplyResponse.cornerWidth = this.supplyService.supplyModel.width;
              }
            }
            supplyResponse.closeButton = tagData.close_button === '1';
            supplyResponse.soundOnHover = tagData.sound_on_hover === '1';
            supplyResponse.pauseOnHiddenTab = tagData.pause_on_hidden_tab === '1';
            supplyResponse.playOnVisibility = this.sharedService.parseNumeric(tagData.play_on_visibility);
            supplyResponse.pauseOnVisibility = this.sharedService.parseNumeric(tagData.pause_on_visibility);
            if (this.sharedService.isEmpty(supplyResponse.playOnVisibility) || supplyResponse.playOnVisibility === 0) {
              supplyResponse.playOnVisibility = this.supplyService.supplyModel.playOnVisibility;
            }
            if (
              this.sharedService.isEmpty(supplyResponse.pauseOnVisibility) ||
              supplyResponse.pauseOnVisibility === 0
            ) {
              supplyResponse.pauseOnVisibility = this.supplyService.supplyModel.pauseOnVisibility;
            }
            supplyResponse.closeOnAdEnd = tagData.close_on_ad_end === '1';
            supplyResponse.closeOnContentEnd = tagData.close_on_content_end === '1';
            supplyResponse.boxHeight = this.sharedService.parseNumeric(tagData.box_height);
            supplyResponse.boxColor = tagData.box_color;
            supplyResponse.persistentWidth = this.sharedService.parseNumeric(tagData.persistent_width);
            supplyResponse.persistentHeight = this.sharedService.parseNumeric(tagData.persistent_height);
            supplyResponse.persistentLocationYPx = this.sharedService.parseNumeric(tagData.persistent_location_y_px);
            supplyResponse.persistentLocationYFrom = ['top', 'bottom'].includes(tagData.persistent_location_y_from)
              ? tagData.persistent_location_y_from
              : 'top';
            supplyResponse.persistentLocationXPx = this.sharedService.parseNumeric(tagData.persistent_location_x_px);
            supplyResponse.persistentLocationXFrom = ['left', 'right'].includes(tagData.persistent_location_x_from)
              ? tagData.persistent_location_x_from
              : 'left';
            supplyResponse.persistentPadding = this.sharedService.parseNumeric(tagData.persistent_padding);
          }
        } else {
          // change domain to cedatoplayer.com if publisher
          const isPublisherNetwork = this.userService.isPublisherNetwork();
          const isCedatoPublisher = this.userService.isCedatoPublisherNetwork();
          const regex = /servingDomain:\s+'(cedatoplayer.com|cedatov.com)'/g;
          const regexUnit = /\/\/c.(cedatoplayer.com|cedatov.com)\/player\//g;
          const domain =
            isPublisherNetwork || isCedatoPublisher ? 'cedatoplayer.com' : this.userService.getDefaultDomainName();
          this.allowedTag = domain !== '';
          this.tagData.tag_code = this.tagData.tag_code.replace(regex, "servingDomain: '" + domain + "'");
          this.tagData.tag_code = this.tagData.tag_code.replace(regexUnit, '//c.' + domain + '/player/');
        }
      }
    }

    // Override empty fields with default values
    for (const property in this.supplyService.supplyModel) {
      if (supplyResponse[property] === undefined && this.supplyService.supplyModel.hasOwnProperty(property)) {
        supplyResponse[property] = this.supplyService.supplyModel[property];
      }
    }
    // Return the supply
    return supplyResponse;
  }

  getNewTagData() {
    const networkURI = !this.sharedService.isEmpty(this.supplyData.networkDomainName)
      ? this.supplyData.networkDomainName.domain
      : '';
    return _.merge(_.cloneDeep(this.supplyService.supplyModel.contentUnitTag), {
      config: {
        playerConfig: {
          player: {
            servingDomain: networkURI,
          },
        },
      },
    });
  }

  goToReport() {
    const queryParams: any = {
      d: `1=${this.supplyData.playerId}`,
    };
    this.router.navigate(['supply/all'], { queryParams: queryParams }).then(() => {
      return;
    });
  }

  onUserMvrInputTypeChanged(inputType: string) {
    switch (inputType) {
      case 'byValue':
        this.supplyData.custom_mvr = true;
        break;

      case 'byScale':
        this.supplyData.custom_mvr = false;
        break;

      default:
        this.supplyData.custom_mvr = false;
    }
  }

  getSupplyPlatforms() {
    const partners: Array<any> = [];
    let partnerMacros: any;
    let enabledForSupplyType: boolean;
    for (let i = 0; i < this.supplyService.supplyPartners.length; i++) {
      partnerMacros = this.supplyService.partnersMacros[this.supplyService.supplyPartners[i].val];
      enabledForSupplyType = partnerMacros.tagTypeRestrictions[this.supplyData.type.toString()];
      if (partnerMacros.enabled && enabledForSupplyType) {
        partners.push(this.supplyService.supplyPartners[i]);
      }
    }
    return partners;
  }

  initPlayerAPI() {
    if (
      this.editMode &&
      this.supplyData.type === 0 &&
      this.supplyData.tagType === 0 &&
      this.playerAPI === undefined &&
      window['CEDATO_API']
    ) {
      this.playerAPI = window['CEDATO_API'].getPlayer(this.previewPlayerId);
    }
  }

  updateTag(userModified: boolean = false) {
    if (this.supplyData.type === 0 || this.supplyData.type === 1) {
      if (this.editMode) {
        const supplyData = this.resetInvalidParams(_.cloneDeep(this.supplyData));
        this.htmlTag = this.generateTag(supplyData, userModified);
        this.previewHTML = this.htmlTag.replace('http://', 'https://');
      }
    }
    this.updateTagPreview();
  }

  private generateTag(supplyData: any, userModified: boolean) {
    if (supplyData.type === SupplyType.CedatoX) {
      return '';
    }
    const networkURI: string = !this.sharedService.isEmpty(supplyData.networkDomainName)
      ? supplyData.networkDomainName.domain
      : '';

    if (supplyData.type == SupplyType.Player && supplyData.tagType >= PlayerTypes.VCU) {
      const currTagType: any = _.find(this.supplyService.tagTypes, { id: this.supplyData.tagType });
      return this.supplyService.generateVCU(supplyData, currTagType.DFP, networkURI);
    } else {
      const playerID: string = !this.duplicateMode
        ? supplyData.playerId.toString()
        : `_duplicated_${this.duplicatedPlayerID}`;
      return this.supplyService.generateBasic(playerID, supplyData, networkURI, (id) => (this.previewPlayerId = id));
    }
  }

  resetInvalidParams(supplyData: any) {
    const currSupplyType: any = _.find(this.supplyService.tagTypes, { id: this.supplyData.tagType });
    if (this.sharedService.isEmpty(supplyData.width) || supplyData.width < 1) {
      supplyData.width = this.supplyService.supplyModel.width;
      if (currSupplyType.defaults) {
        if (currSupplyType.defaults.width) {
          supplyData.width = currSupplyType.width;
        }
      }
    }
    if (this.sharedService.isEmpty(supplyData.domain)) {
      supplyData.domain = this.supplyService.supplyModel.domain;
    }
    if (this.sharedService.isEmpty(supplyData.height) || supplyData.height < 1) {
      supplyData.height = this.supplyService.supplyModel.height;
      if (currSupplyType.defaults) {
        if (currSupplyType.defaults.height) {
          supplyData.height = currSupplyType.height;
        }
      }
    }
    if (this.sharedService.isEmpty(supplyData.ratio) || supplyData.ratio < 0.01) {
      supplyData.ratio = this.supplyService.supplyModel.ratio;
    }
    if (this.supplyData.tagType === 7 || this.supplyData.tagType === 8) {
      if (this.sharedService.isEmpty(supplyData.cornerWidth) || supplyData.cornerWidth < 1) {
        supplyData.cornerWidth = this.supplyService.supplyModel.cornerWidth;
      }
    }
    if (
      this.sharedService.isEmpty(supplyData.playOnVisibility) ||
      supplyData.playOnVisibility < 1 ||
      supplyData.playOnVisibility > 100
    ) {
      supplyData.playOnVisibility = this.supplyService.supplyModel.playOnVisibility;
    }

    if (
      this.sharedService.isEmpty(supplyData.pauseOnVisibility) ||
      supplyData.pauseOnVisibility < 1 ||
      supplyData.pauseOnVisibility > 100
    ) {
      supplyData.pauseOnVisibility = this.supplyService.supplyModel.pauseOnVisibility;
    }
    if (supplyData.playOnVisibility <= supplyData.pauseOnVisibility) {
      supplyData.playOnVisibility = this.supplyService.supplyModel.playOnVisibility;
      supplyData.pauseOnVisibility = this.supplyService.supplyModel.pauseOnVisibility;
    }
    if (this.sharedService.isEmpty(supplyData.boxHeight) || supplyData.boxHeight < 1) {
      supplyData.boxHeight = this.supplyService.supplyModel.boxHeight;
    }
    if (this.sharedService.isEmpty(supplyData.boxColor)) {
      supplyData.boxColor = this.supplyService.supplyModel.boxColor;
    }
    if (this.sharedService.isEmpty(supplyData.persistentWidth) || supplyData.persistentWidth < 1) {
      supplyData.persistentWidth = this.supplyService.supplyModel.persistentWidth;
    }
    if (this.sharedService.isEmpty(supplyData.persistentHeight) || supplyData.persistentHeight < 1) {
      supplyData.persistentHeight = this.supplyService.supplyModel.persistentHeight;
    }
    if (this.sharedService.isEmpty(supplyData.persistentLocationYPx) || supplyData.persistentLocationYPx < 1) {
      supplyData.persistentLocationYPx =
        supplyData.tagType !== 6 ? this.supplyService.supplyModel.persistentLocationYPx : 0;
    }
    if (this.sharedService.isEmpty(supplyData.persistentLocationYFrom)) {
      supplyData.persistentLocationYFrom = this.supplyService.supplyModel.persistentLocationYFrom;
    }
    if (this.sharedService.isEmpty(supplyData.persistentLocationXPx) || supplyData.persistentLocationXPx < 1) {
      supplyData.persistentLocationXPx =
        supplyData.tagType !== 6 ? this.supplyService.supplyModel.persistentLocationXPx : 0;
    }
    if (this.sharedService.isEmpty(supplyData.persistentLocationXFrom)) {
      supplyData.persistentLocationXFrom = this.supplyService.supplyModel.persistentLocationXFrom;
    }
    if (this.sharedService.isEmpty(supplyData.persistentPadding) || supplyData.persistentPadding < 1) {
      supplyData.persistentPadding = this.supplyService.supplyModel.persistentPadding;
    }
    return supplyData;
  }

  updateTagPreview() {
    let preview: HTMLElement;
    let previewScripts: any;
    let currScriptTag: any;
    let tagBasicPlayerInputs: HTMLElement;
    let tagBasicPlayerInputsWidth: number;
    if (this.editMode && !this.duplicateMode) {
      this.deleteScripts();
      this.previewUpdateState = true;
      setTimeout(() => {
        this.previewUpdateState = false;
        setTimeout(() => {
          preview = document.getElementById('preview');
          previewScripts = preview ? Array.from(preview.getElementsByTagName('script')) : [];
          tagBasicPlayerInputs = document.getElementById('tagBasicPlayerInputs');
          previewScripts.forEach((script: any) => {
            currScriptTag = document.createElement('script');
            currScriptTag.src = script.src;
            currScriptTag.type = 'text/javascript';
            document.head.appendChild(currScriptTag);
          });
          if (tagBasicPlayerInputs) {
            tagBasicPlayerInputsWidth = tagBasicPlayerInputs.offsetWidth;
            if (this.previewBlockMode) {
              tagBasicPlayerInputsWidth /= 2;
            }

            this.previewBlockMode =
              tagBasicPlayerInputsWidth < 480 ||
              this.supplyData.width > this.supplyService.supplyModel.width ||
              this.supplyData.height > this.supplyService.supplyModel.height ||
              this.sharedService.layout === 'small';
          }
        }, 100);
      }, 100);
    } else {
      this.previewBlockMode = true;
    }
  }

  deleteScripts() {
    const scripts: Array<any> = Array.from(document.getElementsByTagName('script'));
    scripts.forEach((script: any) => {
      if (!this.scriptsOnInit.includes(script)) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      }
    });
    this.initPlayerAPI();
    if (this.playerAPI && !!this.playerAPI.close) {
      try {
        this.playerAPI.close();
      } catch (error) {
        console.log('error in playerApi.close');
      }
    }
  }

  toggleSection(id: number) {
    this.allSections[id].toggleStatus = !this.allSections[id].toggleStatus;
  }

  goToSection(id: number, goToTag: boolean = false) {
    let section: HTMLElement = !goToTag
      ? document.getElementById(this.allSections[id].value)
      : document.getElementById('tagBlock');
    if (!section && goToTag) {
      section = document.getElementById('unitBlock');
    }
    const yPosition: number = id > 0 ? section.offsetTop : 0;
    window.scroll({ top: yPosition, left: 0, behavior: 'smooth' });
    this.activeSection = id;
    if (!this.allSections[id].toggleStatus) {
      this.toggleSection(id);
    }
    setTimeout(() => {
      this.activeSection = id;
    }, 400);
  }

  getSectionsPosition() {
    return window.scrollY > 72 ? 0 : 72;
  }

  getSectionsArrowPosition() {
    return this.activeSection && document.getElementById('sectionButton' + this.activeSection)
      ? document.getElementById('sectionButton' + this.activeSection).offsetTop
      : 0;
  }

  isSectionActive(id: number) {
    let answer = false;
    const supplyType: any = _.find(this.supplyService.supplyTypes, { id: this.supplyData.type });
    const featureFlag: string = this.supplyService.sideMenuSections[id].featureFlag;
    const isAdminOnly: boolean = this.supplyService.sideMenuSections[id].isAdminOnly;
    if (supplyType) {
      answer = supplyType.sections[id];
    }
    if (answer && this.allSections[id].editModeOnly) {
      answer = this.editMode || this.duplicateMode;
    }
    if (
      this.supplyService.sideMenuSections[id].hasOwnProperty('featureFlag') &&
      this.supplyService.sideMenuSections[id].hasOwnProperty('isAdminOnly')
    ) {
      answer = answer && (this.userService.getFeatureState(featureFlag) || this.userService.isAdmin());
    } else {
      if (featureFlag) {
        answer = answer && this.userService.getFeatureState(featureFlag);
      }
      if (isAdminOnly) {
        answer = answer && this.userService.isAdmin();
      }
    }
    // if (answer && id == 3){
    //   answer = this.isContentSectionActive();
    // }
    return answer;
  }

  buildSideMenuIcons() {
    const activeIconsSet: Array<any> = [];
    for (let i = 0; i < this.supplyService.sideMenuSections.length; i++) {
      if (this.isSectionActive(i)) {
        activeIconsSet.push(this.supplyService.sideMenuSections[i]);
      }
    }
    return activeIconsSet;
  }

  isContentSectionActive() {
    // conditions for content section whether to display or not.
    const isAdmin: boolean = this.userService.isAdmin();
    const isContentUnit: boolean = this.supplyData.sub_type == 1;

    return isAdmin || !isContentUnit;
  }

  onSupplyTypeChange() {
    this.supplyData.costType = this.supplyData.type !== 2 ? 7 : 4;
    if (this.supplyData.type !== 0) {
      this.supplyData.sub_type = 0;
    }
    this.refreshAssignedGrid();
  }

  getSelectedPartner() {
    const item: any = _.find(this.partners, { value: parseInt(this.supplyData.partnerId) });
    let index = -1;
    if (item) {
      index = this.partners.indexOf(item);
      if (index !== -1) {
        return index;
      }
    }
    return index;
  }

  onPartnerSelect($event: any) {
    if ($event === null) {
      this.supplyData.partnerId = null;
      this.supplyData.partnerName = null;
    } else {
      if ($event.value === -1) {
        this.supplyData.partnerId = -1;
        this.supplyData.partnerName = $event.label;
        this.partners.push($event);
      } else {
        this.supplyData.partnerId = $event.value;
        this.supplyData.partnerName = null;
      }
    }
  }

  goToCxVast() {
    this.router.navigate(['/demand/manage/' + this.supplyData.cedatoXVastId]).then(() => {
      return;
    });
  }

  verifyNetworkForCedatoX() {
    if (
      !this.sharedService.isEmpty(this.supplyData.partnerNetworkId) &&
      this.sharedService.isNumeric(this.supplyData.partnerNetworkId)
    ) {
      if (this.supplyData.partnerNetworkId !== this.partnerNetworkIdOnFocus) {
        this.verifyNetworkForCedatoXLoading = true;
        this.verifyNetworkForCedatoXConfirmed = false;
        this.subscriptions.push(
          this.httpService
            .post('vdsp_ws/verifyNetworkForCedatoX', { affiliate_network_id: this.supplyData.partnerNetworkId })
            .subscribe((response) => {
              if (response.status === 'OK') {
                this.supplyData.partnerNetworkName = response.network.affiliate_network_name;
                this.modalsService.showModal({
                  title: this.dictionaryService.get('CEDATOX_CONNECTION'),
                  component: 'cedatox-confirm',
                  data: {
                    networkId: response.network.affiliate_network_id,
                    networkName: response.network.affiliate_network_name,
                  },
                });
              } else {
                this.sharedService.showFlashMessage(response.error, 'error');
                this.verifyNetworkForCedatoXConfirmed = false;
                this.supplyData.partnerNetworkId = '';
                this.supplyData.partnerNetworkName = '';
              }
              this.verifyNetworkForCedatoXLoading = false;
            })
        );
      }
    } else {
      this.supplyData.partnerNetworkId = null;
      this.supplyData.partnerNetworkName = '';
      this.verifyNetworkForCedatoXConfirmed = false;
    }
  }

  onPartnerNetworkIdChange() {
    if (this.sharedService.isEmpty(this.supplyData.partnerNetworkId)) {
      this.verifyNetworkForCedatoXConfirmed = false;
    }
  }

  toggleEnvironment(environment: string) {
    this.supplyData[environment] = !this.supplyData[environment];

    if (this.supplyData.is_ctv && this.supplyData.type === SupplyType.Vast) {
      this.supplyData.sub_type = VastSubTypes.Vast2Vast;
    }

    const oldMobileApp: boolean = this.supplyData.mobileApp;
    const newMobileApp = this.supplyData.is_mobile_app
      ? !(this.supplyData.is_desktop || this.supplyData.is_mobile_web || this.supplyData.is_ctv)
      : false;
    if (oldMobileApp !== newMobileApp) {
      this.onMobileChange();
    } else {
      this.updateTag();
    }
  }

  onVASTRequestLimit($event: any) {
    this.supplyData.vastRequestLimit = $event;
  }

  onPlayerSizeChange($event: any) {
    const playerSize: any = _.find(this.supplyService.playerSizes, { val: $event.val });
    if (playerSize.width && playerSize.height) {
      this.supplyData.width = playerSize.width;
      this.supplyData.height = playerSize.height;
    }
    this.updateTag();
  }

  onBoxColorChange($event: any) {
    this.supplyData.boxColor = $event;
    this.updateTag();
  }

  onTagTypeChange($event: any) {
    const currSupplyType: any = _.find(this.supplyService.tagTypes, { id: this.supplyData.tagType });
    let currSizeTypeInNewTagType: any;
    if (this.supplyData.tagType !== 0) {
      currSizeTypeInNewTagType = _.find(this.supplyData.sizeType, (sizeType: any) => {
        return sizeType.value === this.supplyData.sizeType;
      });
      if (currSizeTypeInNewTagType === undefined) {
        this.supplyData.sizeType = currSupplyType.sizeTypes[0].value;
      }
      if (currSupplyType.defaults) {
        for (const property of Object.keys(currSupplyType.defaults)) {
          this.supplyData[property] = currSupplyType.defaults[property];
        }
      }
    }
    this.updateTag();
  }

  onSizeTypeChange($event: any) {
    this.supplyData.sizeType = $event;
    this.updateTag();
  }

  onTagPropertyChange(property: string, value: any) {
    this.supplyData[property] = value;
    this.updateTag();
  }

  togglePassback() {
    this.onTagPropertyChange('passback', !this.supplyData.passback);
    if (this.supplyData.passback && this.supplyData.passbackTimeout < this.passbackTimeoutMin) {
      this.supplyData.passbackTimeout = this.passbackTimeoutMin;
    }
    this.updateTagPreview();
  }

  onHBChange() {
    const costTypeNone = this.supplyService.hbCostType;
    this.supplyData.hb = !this.supplyData.hb;
    this.supplyData.costType =
      this.supplyData.hb && this.supplyData.type != 2 ? costTypeNone : this.supplyData.costType;
  }

  onTargetingChange(items: any, type: string) {
    let versions: Array<any>;
    switch (type) {
      case 'browsers':
        for (let i = 0; i < items.length; i++) {
          versions = this.getBrowserVersions(items[i].name);
          if (items[i].from === undefined || items[i].hasOwnProperty('isNewItem')) {
            items[i].from = versions[0];
          }
          if (items[i].to === undefined || items[i].hasOwnProperty('isNewItem')) {
            items[i].to = versions[versions.length - 1];
          }
        }
        break;

      case 'os':
        for (let i = 0; i < items.length; i++) {
          versions = this.getOSVersions(items[i].name);
          if (items[i].from === undefined || items[i].hasOwnProperty('isNewItem')) {
            items[i].from = versions[0];
          }
          if (items[i].to === undefined || items[i].hasOwnProperty('isNewItem')) {
            items[i].to = versions[versions.length - 1];
          }
        }
        break;

      case 'location':
      case 'dma':
      case 'state':
        if (!this.isTargetingDMAEnabled()) {
          if (this.targeting.dma) {
            this.sharedService.showFlashMessage(this.dictionaryService.get('DMA_DISABLED_POPUP'), 'warning');
          }
          this.targeting.dma = false;
          this.supplyData.targeting.dma.type = 0;
          this.supplyData.targeting.dma.list = [];
        }
        if (!this.isTargetingStatesEnabled()) {
          // Here add states things to do when toggle change
          this.targeting.state = false;
          this.supplyData.targeting.state.type = 0;
          this.supplyData.targeting.state.list = [];
        }
        break;
    }
  }

  isTargetingDMAEnabled(): boolean {
    const isLocationTypeInclude = this.supplyData.targeting.location.type == 1;
    const USincluded = typeof _.find(this.supplyData.targeting.location.list, { iso: 'US' }) !== 'undefined';
    const isTargetingStatesEnabled = this.targeting.state;
    const result = isLocationTypeInclude == USincluded && this.targeting.location && !isTargetingStatesEnabled;
    if (!result) {
      this.supplyData.targeting.dma.type = 0;
      this.supplyData.targeting.dma.list = [];
    }
    return result;
  }
  isTargetingStatesEnabled(): boolean {
    const isLocationTypeInclude = this.supplyData.targeting.location.type == 1;
    const USincluded = typeof _.find(this.supplyData.targeting.location.list, { iso: 'US' }) !== 'undefined';
    const isTargetingDMAEnabled = this.targeting.dma;
    const result = isLocationTypeInclude == USincluded && this.targeting.location && !isTargetingDMAEnabled;

    if (!result) {
      this.supplyData.targeting.state.type = 0;
      this.supplyData.targeting.state.list = [];
    }
    return result;
  }
  getBrowserVersions(browserName: string) {
    const browser: any = _.find(this.sharedService.targetingLookups.browserVersions, { name: browserName });
    const versions: Array<any> = browser.versions.split(',');
    for (let i = 0; i < versions.length; i++) {
      versions[i] = versions[i].trim();
    }
    versions.push(this.dictionaryService.get('LATEST'));
    return versions;
  }

  getOSVersions(osName: string) {
    const os: any = _.find(this.sharedService.targetingLookups.osVersions, { name: osName });
    const versions: Array<any> = os.versions.split(',');
    for (let i = 0; i < versions.length; i++) {
      versions[i] = versions[i].trim();
    }
    versions.push(this.dictionaryService.get('LATEST'));
    return versions;
  }

  getCustomPlayerSizeRestrictions() {
    return _.filter(this.supplyData.targeting.targetingSizes.list, { custom: true });
  }

  getCappingPlaceholder(id: number) {
    let placeholder: string = this.dictionaryService.get('MIN') + ' ';
    if (id === 0) {
      placeholder += '10,000';
    } else if (id === 1) {
      placeholder += this.supplyData.player_capping[1].paceOption === 1 ? '100,000' : '5,000,000';
    }
    return placeholder;
  }

  onCappingChange(id: number, value: any) {
    const num: number = this.sharedService.strToInt(value);
    this.supplyData.player_capping[id].cappingValue = num ? this.sharedService.toLocaleString(num) : '';
  }

  getCallbackEvents(currItem: any) {
    const availableCallbacks: Array<any> = [];
    let isAvailable: boolean;
    let callbacksOfCurrType: Array<any>;
    this.eventsList = [];
    for (let i = 0; i < this.supplyService.eventsList.length; i++) {
      isAvailable = false;
      if (this.supplyService.eventsList[i].featureFlag) {
        if (this.userService.getFeatureState(this.supplyService.eventsList[i].featureFlag)) {
          isAvailable = true;
        }
      } else {
        isAvailable = true;
      }
      if (isAvailable) {
        callbacksOfCurrType = _.filter(this.supplyData.callbacks, { event: this.supplyService.eventsList[i] });
        if (callbacksOfCurrType.length < 2 || currItem.event === this.supplyService.eventsList[i]) {
          availableCallbacks.push(this.supplyService.eventsList[i]);
        }
      }
    }
    return availableCallbacks;
  }

  getAvailableCallbacks() {
    const currCallbacks: Array<number> = _.map(this.supplyData.callbacks, 'event');
    const availableCallbacks: Array<number> = [];
    for (let i = 0; i < this.supplyService.eventsList.length; i++) {
      if (
        _.filter(currCallbacks, {
          eventId: this.supplyService.eventsList[i].eventId,
          typeId: this.supplyService.eventsList[i].typeId,
        }).length < 2
      ) {
        availableCallbacks.push(this.supplyService.eventsList[i]);
      }
    }
    return availableCallbacks;
  }

  addCallback() {
    this.supplyData.callbacks.push({ url: '', event: this.getAvailableCallbacks()[0], rate: 100 });
  }

  removeCallback(callbackIndex: number) {
    this.supplyData.callbacks.splice(callbackIndex, 1);
  }

  validateCapping() {
    let valid = true;
    let value: number;
    if (this.supplyData.player_capping[0].active) {
      value = parseInt(this.sharedService.cleanString(this.supplyData.player_capping[0].cappingValue, [',']));
      if (value < 10000) {
        valid = false;
      }
    }
    if (this.supplyData.player_capping[1].active) {
      value = parseInt(this.sharedService.cleanString(this.supplyData.player_capping[1].cappingValue, [',']));
      if (this.supplyData.player_capping[1].paceOption === 1) {
        if (value < 100000) {
          valid = false;
        }
      } else if (this.supplyData.player_capping[1].paceOption === 2) {
        if (value < 5000000) {
          valid = false;
        }
      }
    }
    return valid;
  }

  viewAvailableMacros() {
    this.modalsService.showModal({
      component: 'available-macros',
      title: this.dictionaryService.get('AVAILABLE_MACROS'),
      data: { type: 'supply' },
    });
  }

  onMobileChange() {
    this.supplyData.subId = this.supplyData.mobileApp ? 'EXTRACTED_DOMAIN' : '[APP_BUNDLE]';
    this.onTagPropertyChange('mobileApp', !this.supplyData.mobileApp);
  }

  getSizeTypes() {
    const currSupplyType: any = _.find(this.supplyService.tagTypes, { id: this.supplyData.tagType });
    return currSupplyType.sizeTypes;
  }

  validateTargeting() {
    let compareResult: number;
    const customPlayerSizeRestrictions: Array<any> = this.getCustomPlayerSizeRestrictions();
    if (this.supplyData.targeting.location.type !== 0 && this.supplyData.targeting.location.list.length === 0) {
      this.errorInputs.push('targetingLocation');
    }
    if (this.supplyData.targeting.state.type !== 0 && this.supplyData.targeting.state.list.length === 0) {
      this.errorInputs.push('targetingStates');
    }
    if (this.supplyData.targeting.browsers.type !== 0) {
      if (this.supplyData.targeting.browsers.list.length === 0) {
        this.errorInputs.push('targetingBrowsers');
      } else {
        for (let i = 0; i < this.supplyData.targeting.browsers.list.length; i++) {
          if (this.supplyData.targeting.browsers.list[i].to.toLowerCase() !== 'latest') {
            compareResult = this.sharedService.versionCompare(
              this.supplyData.targeting.browsers.list[i].from,
              this.supplyData.targeting.browsers.list[i].to
            );
            if (_.isNaN(compareResult) || compareResult > 0) {
              this.errorInputs.push('targetingBrowsersFromTo');
            }
          }
        }
      }
    }
    if (this.supplyData.targeting.os.type !== 0) {
      if (this.supplyData.targeting.os.list.length === 0) {
        this.errorInputs.push('targetingOS');
      } else {
        for (let i = 0; i < this.supplyData.targeting.os.list.length; i++) {
          if (this.supplyData.targeting.os.list[i].to.toLowerCase() !== 'latest') {
            compareResult = this.sharedService.versionCompare(
              this.supplyData.targeting.os.list[i].from,
              this.supplyData.targeting.os.list[i].to
            );
            if (_.isNaN(compareResult) || compareResult > 0) {
              this.errorInputs.push('targetingOSFromTo');
            }
          }
        }
      }
    }
    if (
      this.supplyData.targeting.targetingSizes.type !== 0 &&
      this.supplyData.targeting.targetingSizes.list.length === 0
    ) {
      this.errorInputs.push('targetingSize');
    }
    for (let i = 0; i < customPlayerSizeRestrictions.length; i++) {
      if (
        customPlayerSizeRestrictions[i].width < 1 ||
        customPlayerSizeRestrictions[i].width > 99999 ||
        customPlayerSizeRestrictions[i].height < 1 ||
        customPlayerSizeRestrictions[i].height > 99999
      ) {
        this.errorInputs.push('targetingSizeWidthHeight');
      }
    }
    if (this.supplyData.targeting.dma.type !== 0 && this.supplyData.targeting.dma.list.length === 0) {
      this.errorInputs.push('targetingDMA');
    }
  }

  validateForm() {
    this.errorInputs = [];
    this.supplyData.callbacks.forEach((callback: any) => {
      callback.url = callback.url.replace(' ', '%20');
    });

    if (this.supplyData.type !== 2 && this.userService.isAdmin() && this.supplyData.extra_params_enabled) {
      this.validateExtraParamsJSON();
      this.validateExtraParamsURL();
    }

    if (!this.validateCapping()) {
      this.errorInputs.push('capping');
    }

    this.validateTargeting();

    if (this.sharedService.isEmpty(this.supplyData.name)) {
      this.errorInputs.push('supplyName');
    }

    if (
      !(
        this.supplyData.is_desktop ||
        this.supplyData.is_mobile_web ||
        this.supplyData.is_mobile_app ||
        this.supplyData.is_ctv
      )
    ) {
      this.errorInputs.push('environment');
    }

    if (
      this.supplyData.costType !== 7 &&
      (this.sharedService.isEmpty(this.supplyData.costValue) || this.supplyData.costValue < 0.01)
    ) {
      this.errorInputs.push('costValue');
    }

    if (this.supplyData.floorCPMPrice < 0) {
      this.errorInputs.push('floorCPM');
    }

    if (this.supplyData.type === 2 && !this.verifyNetworkForCedatoXConfirmed) {
      this.errorInputs.push('partnerNetworkId');
    }

    if (
      !this.supplyData.asSoonAsAvailable &&
      !this.supplyData.preRoll &&
      !this.supplyData.midRoll &&
      !this.supplyData.postRoll
    ) {
      this.errorInputs.push('playAd');
    }

    // if (this.supplyData.preRoll && !(this.supplyData.preRollTime >= 1))
    //   this.errorInputs.push('preroll');

    // if (this.supplyData.midRoll && !(this.supplyData.midRollFirstAdTime >= 1 && this.supplyData.midRollInterval && this.supplyData.midRollAllowedAdDelay))
    //   this.errorInputs.push('midroll');

    // if (this.supplyData.midRoll && !(this.supplyData.midRollAllowedAdDelay < this.supplyData.midRollInterval))
    //   this.errorInputs.push('midrollInvalid');

    if (
      this.supplyData.maxAdRequestsPerOpportunity &&
      (this.sharedService.isEmpty(this.supplyData.maxTotalVastRequests) || this.supplyData.maxTotalVastRequests <= 0)
    ) {
      this.errorInputs.push('maxAdRequests');
    }

    if (this.supplyData.type === 0 && this.supplyData.tagType === 0 && this.supplyData.playerSize.val === 'Custom') {
      if (this.sharedService.isEmpty(this.supplyData.width) || this.supplyData.width <= 0) {
        this.errorInputs.push('width');
      }

      if (this.sharedService.isEmpty(this.supplyData.height) || this.supplyData.height <= 0) {
        this.errorInputs.push('height');
      }
    }
    if (
      this.supplyData.passback &&
      (this.supplyData.passbackTimeout < this.passbackTimeoutMin ||
        this.supplyData.passbackTimeout > this.passbackTimeoutMax)
    ) {
      this.errorInputs.push('passbackTimeout');
    }

    if (this.supplyData.passback && this.sharedService.isEmpty(this.supplyData.passbackCode)) {
      this.errorInputs.push('passbackCode');
    }

    if (
      this.supplyData.type !== 0 &&
      this.supplyData.domainListType !== 0 &&
      this.supplyData.domainLists.length === 0
    ) {
      this.errorInputs.push('domainLists');
    }

    if (this.supplyData.type !== 0 && this.supplyData.urlListType !== 0 && this.supplyData.urlLists.length === 0) {
      this.errorInputs.push('urlLists');
    }

    if (this.supplyData.type !== 0 && this.supplyData.ipListType !== 0 && this.supplyData.ipLists.length === 0) {
      this.errorInputs.push('ipLists');
    }

    if (this.supplyData.domainListType !== 0 && this.supplyData.domainLists.length > this.supplyService.listsLimit) {
      this.errorInputs.push('listsLimit');
    }

    if (this.supplyData.ipListType !== 0 && this.supplyData.ipLists.length > this.supplyService.ipListsLimit) {
      this.errorInputs.push('ipListsLimit');
    }

    if (
      this.supplyData.custom_mvr &&
      (this.supplyData.custom_vastRequestLimit > 49 ||
        this.supplyData.custom_vastRequestLimit == 0 ||
        this.sharedService.isEmpty(this.supplyData.custom_vastRequestLimit))
    ) {
      this.errorInputs.push('user_mvr');
    }

    if (
      this.supplyData.custom_mvr &&
      (this.supplyData.custom_vastRequestLimit > 49 ||
        this.supplyData.custom_vastRequestLimit === 0 ||
        this.sharedService.isEmpty(this.supplyData.custom_vastRequestLimit))
    ) {
      this.errorInputs.push('user_mvr');
    }

    if (!this.callbacksService.validateNoEmptyCallbacks(this.supplyData.callbacks)) {
      this.errorInputs.push('callbacksEmpty');
    } else if (!this.callbacksService.validatCallbacksURLs(this.supplyData.callbacks)) {
      this.errorInputs.push('callbacksURL');
    }

    if (!this.callbacksService.validateIVTCallbacks(this.supplyData.callbacks)) {
      this.errorInputs.push('callbacksIVT');
    }

    if (!this.callbacksService.validateUniqueCallbacks(this.supplyData.callbacks)) {
      this.errorInputs.push('callbacksDoubled');
    }

    if (!this.callbacksService.validateCallbacksRates(this.supplyData.callbacks)) {
      this.errorInputs.push('callbacksRate');
    }

    // Adding additional checking for targeting vendor domain. But warning will appear in restrictions
    if (this.supplyData.targeting.vast_domains.type !== 0) {
      const anyInvalidDomains =
        this.supplyData.targeting.vast_domains.list.filter((domain) => {
          return !this.sharedService.validateURL(domain);
        }).length > 0;
      if (anyInvalidDomains) {
        this.errorInputs.push('vendor_blacklist');
      }
    }

    if (this.supplyData.type == 0) {
      if (this.supplyData.tagType !== 7 && this.supplyData.tagType !== 8) {
        if (this.supplyData.sizeType === 1) {
          if (this.supplyData.width < 1) {
            this.errorInputs.push('width');
          }
          if (this.supplyData.height < 1) {
            this.errorInputs.push('height');
          }
        } else if (this.supplyData.sizeType === 2) {
          if (this.supplyData.ratio < 0.01) {
            this.errorInputs.push('ratio');
          }
        }
      } else {
        if (this.supplyData.sizeType === 0) {
          if (this.supplyData.width < 1) {
            this.errorInputs.push('width');
          }
          if (this.supplyData.ratio < 0.01) {
            this.errorInputs.push('ratio');
          }
        } else if (this.supplyData.sizeType === 1) {
          if (this.supplyData.width < 1) {
            this.errorInputs.push('width');
          }
          if (this.supplyData.height < 1) {
            this.errorInputs.push('height');
          }
        }
      }
      if (this.supplyData.tagType === 7 && this.supplyData.tagType === 8) {
        if (this.supplyData.playOnVisibility <= this.supplyData.pauseOnVisibility) {
          this.errorInputs.push('nativeVisibilityRatio');
        }
        if (
          this.supplyData.playOnVisibility < 1 ||
          this.supplyData.playOnVisibility > 100 ||
          this.supplyData.pauseOnVisibility < 1 ||
          this.supplyData.pauseOnVisibility > 100
        ) {
          this.errorInputs.push('nativeVisibility');
        }
      }
      if (this.supplyData.tagType === 4 || this.supplyData.tagType == 6) {
        if (this.supplyData.persistentWidth < 1) {
          this.errorInputs.push('persistentWidth');
        }
        if (this.supplyData.persistentHeight < 1) {
          this.errorInputs.push('persistentHeight');
        }
        if (this.supplyData.persistentLocationYPx < 1) {
          this.errorInputs.push('persistenY');
        }
        if (this.supplyData.persistentLocationXPx < 1) {
          this.errorInputs.push('persistenX');
        }
        if (this.supplyData.persistentPadding < 1) {
          this.errorInputs.push('persistentPadding');
        }
      }
    }

    this.errorInputs = _.uniq(this.errorInputs);
    if (this.errorInputs.length) {
      this.sharedService.onEntitySaveFailure();
    }
    return this.errorInputs.length === 0;
  }

  validateExtraParamsJSON(json?: any) {
    this.errorInputs = _.without(this.errorInputs, 'extra_params', 'extra_params_not_defined', 'extra_params_too_long');

    if (json === undefined) {
      try {
        json = JSON.parse(this.supplyData.extra_params);
      } catch {}
    }
    if (!json || typeof json !== 'object') {
      this.errorInputs.push('extra_params');
    } else {
      if (
        Object.keys(json).length == 0 &&
        this.supplyData.extra_params_url === this.supplyService.extraParamsDefaultValue.url
      ) {
        this.errorInputs.push('extra_params_not_defined');
      } else if (stringify(json).length > +this.supplyService.extraParamsDefaultValue.extra_params_length) {
        this.errorInputs.push('extra_params_too_long');
      }
    }
    this.errorInputs = _.uniq(this.errorInputs);
    return this.errorInputs.length == 0;
  }

  validateExtraParamsURL() {
    if (
      !this.sharedService.isURLParams(this.supplyData.extra_params_url) &&
      this.supplyData.extra_params_url !== this.supplyService.extraParamsDefaultValue.url
    ) {
      this.errorInputs.push('extra_params_url');
    } else {
      this.errorInputs = _.without(this.errorInputs, 'extra_params_url');
      if (
        stringify(JSON.parse(this.supplyData.extra_params)) ===
          stringify(JSON.parse(this.supplyService.extraParamsDefaultValue.json)) &&
        this.supplyData.extra_params_url === this.supplyService.extraParamsDefaultValue.url
      ) {
        this.errorInputs.push('extra_params_not_defined');
      } else {
        this.errorInputs = _.without(this.errorInputs, 'extra_params_not_defined');
      }
    }
    this.errorInputs = _.uniq(this.errorInputs);
  }

  cancel() {
    this.router.navigate(['/supply/manage']).then(() => {
      return;
    });
  }

  save(close: boolean = false) {
    const noErrors: boolean = this.validateForm();
    const supplyToSave: any = {};
    let player_capping: Array<any> = [];
    const callbacks: Array<any> = [];
    const domainLists: Array<any> = [];
    const urlLists: Array<any> = [];
    const ipLists: Array<any> = [];
    const targeting: any = {};
    const supplyXPartnerAllowed: boolean =
      this.userService.networkData.mpnid.includes(+this.userService.networkData.networkId) &&
      +this.supplyData.partnerNetworkId === +this.userService.networkData.pbnid;
    this.newPartner = false;
    if (noErrors) {
      if (
        this.supplyData.type === 2 &&
        this.supplyData.costType === 4 &&
        (this.supplyData.costValue <= 49 || this.supplyData.costValue >= 91) &&
        !this.cxRevshareConfirm
      ) {
        this.modalsService.showModal({
          component: 'cx-revshare-confirm',
          title: this.dictionaryService.get('CEDATOX_SUPPLY_REVSHARE_COMMENT_TITLE'),
          data: {
            costValue: this.supplyData.costValue,
          },
        });
        return;
      }
      // Supply ID
      if (this.editMode && !this.duplicateMode) {
        supplyToSave.playerId = this.supplyData.playerId;
      }
      // Settings
      supplyToSave.player_type = this.supplyData.type;
      supplyToSave.sub_type = this.supplyData.sub_type;
      supplyToSave.player_name = this.supplyData.name;
      supplyToSave.is_active = this.supplyData.active;
      supplyToSave.limit_assign = this.supplyData.limitAssign;
      supplyToSave.hb = this.supplyData.hb;
      supplyToSave.limit_assign_override = this.assignOverrideSettings.state;
      supplyToSave.is_desktop = this.supplyData.is_desktop;
      supplyToSave.is_mobile_app = this.supplyData.is_mobile_app;
      supplyToSave.is_mobile_web = this.supplyData.is_mobile_web;
      supplyToSave.is_ctv = this.supplyData.is_ctv;
      supplyToSave.isMobile = supplyToSave.is_mobile_app || supplyToSave.is_mobile_web;
      if (this.supplyData.type !== 2 || (this.supplyData.type === 2 && supplyXPartnerAllowed)) {
        if (!this.sharedService.isEmpty(this.supplyData.partnerId)) {
          supplyToSave.partnerID = this.supplyData.partnerId;
        }
        if (!this.sharedService.isEmpty(this.supplyData.partnerName)) {
          supplyToSave.partnerName = this.supplyData.partnerName;
          delete supplyToSave.partnerID;
          this.newPartner = true;
        }
      } else {
        supplyToSave.partnerName = this.supplyData.partnerNetworkName;
      }
      supplyToSave.floor_cpm_price = this.supplyData.floorCPMPrice;
      supplyToSave.cost_type = this.supplyData.costType;
      supplyToSave.cost_value = this.supplyData.costValue;
      supplyToSave.isMuted = !this.supplyData.allowSound;
      supplyToSave.rotate = this.supplyData.rotation;
      supplyToSave.rotate_number = this.supplyData.rotationNumber;
      supplyToSave.autoplay = this.supplyData.autoPlay;
      supplyToSave.controlbar = this.supplyData.controlBar;
      supplyToSave.affiliate_network_id = this.sharedService.isEmpty(this.supplyData.partnerNetworkId)
        ? null
        : this.supplyData.partnerNetworkId;
      supplyToSave.affiliate_network_name = this.sharedService.isEmpty(this.supplyData.partnerNetworkName)
        ? null
        : this.supplyData.partnerNetworkName;
      // Assigned Demand
      supplyToSave.assigned_vasts = this.assignedEntities;
      supplyToSave.assigned_vasts.forEach((assignedEntity: any) => {
        delete assignedEntity.$$defaultCPM;
        delete assignedEntity.$$selected;
      });

      supplyToSave.extra_params_enabled = this.supplyData.extra_params_enabled ? 1 : 0;
      if (this.supplyData.extra_params_enabled) {
        supplyToSave.extra_params = stringify(JSON.parse(this.supplyData.extra_params));
        supplyToSave.extra_params_url = this.supplyData.extra_params_url;
      }

      // Content
      supplyToSave.loader_image_url = this.supplyData.contentImage;
      supplyToSave.content_url = this.supplyData.contentVideo;
      supplyToSave.content_url_shuffle = this.supplyData.shuffleVideoPlaylist ? 1 : 0;
      supplyToSave.content_video_desc = this.supplyData.videoDescription;
      supplyToSave.content_video_keywords = this.supplyData.videoKeywords;
      supplyToSave.content_video_title = this.supplyData.videoTitle;
      supplyToSave.preroll = this.supplyData.preRoll;
      supplyToSave.preroll_time = this.supplyData.preRollTime;
      supplyToSave.midroll = this.supplyData.midRoll;
      supplyToSave.midroll_allowed_ad_delay = this.supplyData.midRollAllowedAdDelay;
      supplyToSave.midroll_first_ad_time = this.supplyData.midRollFirstAdTime;
      supplyToSave.midroll_interval = this.supplyData.midRollInterval;
      supplyToSave.content_play_full = this.supplyData.postRoll;
      supplyToSave.content_loop = this.supplyData.loopContent;
      supplyToSave.content_control_bar = this.supplyData.contentControlBar;
      supplyToSave.content_url_click = this.supplyData.clickURL;
      // Restrictions
      supplyToSave.custom_mvr = this.supplyData.custom_mvr ? 1 : 0;
      if (this.supplyData.custom_mvr) {
        supplyToSave.user_mvr = this.supplyData.custom_vastRequestLimit;
      } else {
        supplyToSave.user_mvr = this.supplyData.vastRequestLimit;
      }
      supplyToSave.max_total_vast_requests = this.supplyData.maxAdRequestsPerOpportunity
        ? this.supplyData.maxTotalVastRequests
        : null;
      if (this.supplyData.type === 2) {
        supplyToSave.cx_traffic_source_allowed_html = this.supplyData.cxTrafficSourceAllowedHTML ? 1 : 0;
        supplyToSave.cx_traffic_source_allowed_vast = this.supplyData.cxTrafficSourceAllowedVAST ? 1 : 0;
      }
      supplyToSave.domain_list_type = this.supplyData.domainListType;
      if (supplyToSave.domain_list_type !== 0) {
        for (let i = 0; i < this.supplyData.domainLists.length; i++) {
          domainLists.push(parseInt(this.supplyData.domainLists[i].id));
        }
      }
      supplyToSave.url_list_type = this.supplyData.urlListType;
      if (supplyToSave.url_list_type !== 0) {
        for (let i = 0; i < this.supplyData.urlLists.length; i++) {
          urlLists.push(parseInt(this.supplyData.urlLists[i].id));
        }
      }
      supplyToSave.domain_restriction_lists = domainLists;
      supplyToSave.url_restriction_lists = urlLists;
      supplyToSave.ip_list_type = this.supplyData.ipListType;
      if (supplyToSave.ip_list_type !== 0) {
        for (let i = 0; i < this.supplyData.ipLists.length; i++) {
          ipLists.push(parseInt(this.supplyData.ipLists[i].id));
        }
      }
      supplyToSave.ip_restriction_lists = ipLists;
      player_capping = _.cloneDeep(this.supplyData.player_capping);
      player_capping = _.filter(player_capping, { active: true });
      for (let i = 0; i < player_capping.length; i++) {
        player_capping[i].cappingValue = this.sharedService.strToInt(player_capping[i].cappingValue);
        delete player_capping[i].active;
      }
      supplyToSave.player_capping = player_capping;
      // Callbacks
      for (let i = 0; i < this.supplyData.callbacks.length; i++) {
        if (
          this.supplyData.callbacks[i].url.indexOf('http://') !== 0 &&
          this.supplyData.callbacks[i].url.indexOf('https://') !== 0
        ) {
          this.supplyData.callbacks[i].url = 'http://' + this.supplyData.callbacks[i].url;
        }
        callbacks.push({
          url: this.supplyData.callbacks[i].url,
          eventId: this.supplyData.callbacks[i].event.eventId,
          typeId: this.supplyData.callbacks[i].event.typeId,
          rate: this.supplyData.callbacks[i].rate,
        });
        if (this.supplyData.callbacks[i].callbackId) {
          callbacks[i].callbackId = this.supplyData.callbacks[i].callbackId;
        }
      }
      supplyToSave.callbacks = callbacks;

      // Targeting
      if (this.supplyData.type === 1 || this.supplyData.type === 2) {
        if (this.supplyData.is_mobile_app && this.supplyData.targeting.app_bundle_oper) {
          targeting.app_bundle_oper = 1;
        }

        if (
          !!(this.supplyData.is_desktop || this.supplyData.is_mobile_web) &&
          this.supplyData.targeting.detected_domain_oper
        ) {
          targeting.detected_domain_oper = 1;
        }
      }

      if (this.supplyData.type === 1) {
        if (this.supplyData.targeting.targeting_id) {
          targeting.targeting_id = this.supplyData.targeting.targeting_id;
        }
        supplyToSave.targeting = targeting;
      }

      if (this.supplyData.type === 2) {
        // Browsers
        targeting.browsers_oper = 0;
        targeting.browsers = '';
        if (this.targeting.browsers) {
          targeting.browsers_oper = this.supplyData.targeting.browsers.type;
          for (let i = 0; i < this.supplyData.targeting.browsers.list.length; i++) {
            targeting.browsers += (
              this.supplyData.targeting.browsers.list[i].code +
              ':' +
              this.supplyData.targeting.browsers.list[i].from +
              '-' +
              this.supplyData.targeting.browsers.list[i].to
            ).toLowerCase();
            if (i + 1 < this.supplyData.targeting.browsers.list.length) {
              targeting.browsers += ',';
            }
          }
        }
        // Categories
        targeting.categs_oper = 0;
        targeting.categs = '';
        // Countries
        targeting.country_codes_oper = 0;
        targeting.country_codes = '';
        if (this.targeting.location) {
          targeting.country_codes_oper = this.supplyData.targeting.location.type;
          for (let i = 0; i < this.supplyData.targeting.location.list.length; i++) {
            targeting.country_codes += this.supplyData.targeting.location.list[i].iso;
            if (i + 1 < this.supplyData.targeting.location.list.length) {
              targeting.country_codes += ',';
            }
          }
        }

        // OS
        targeting.os = '';
        targeting.os_oper = 0;
        if (this.targeting.os) {
          targeting.os_oper = this.supplyData.targeting.os.type;
          for (let i = 0; i < this.supplyData.targeting.os.list.length; i++) {
            targeting.os += (
              this.supplyData.targeting.os.list[i].code +
              ':' +
              this.supplyData.targeting.os.list[i].from +
              '-' +
              this.supplyData.targeting.os.list[i].to
            ).toLowerCase();
            if (i + 1 < this.supplyData.targeting.os.list.length) {
              targeting.os += ',';
            }
          }
        }

        // Targeting supply ID
        targeting.player_id = this.supplyData.playerId;

        // Sizes
        targeting.sizes_oper = 0;
        targeting.sizes = '';
        targeting.sizes_ui = '';
        if (this.targeting.targetingSizes) {
          targeting.sizes_oper = this.supplyData.targeting.targetingSizes.type;
          for (let i = 0; i < this.supplyData.targeting.targetingSizes.list.length; i++) {
            if (this.supplyData.targeting.targetingSizes.list[i].targeting_playerSize_id) {
              targeting.sizes += this.supplyData.targeting.targetingSizes.list[i].targeting_playerSize_id;
              targeting.sizes_ui += '|';
            } else {
              targeting.sizes += this.supplyService.getCustomPlayerSizeId(
                this.supplyData.targeting.targetingSizes.list[i].width,
                this.supplyData.targeting.targetingSizes.list[i].height,
                this.supplyData.targeting.targetingSizes.list[i].operator
              );
              targeting.sizes_ui += JSON.stringify({
                n: this.supplyData.targeting.targetingSizes.list[i].name,
                w: parseInt(this.supplyData.targeting.targetingSizes.list[i].width),
                h: parseInt(this.supplyData.targeting.targetingSizes.list[i].height),
                o: this.supplyData.targeting.targetingSizes.list[i].operator,
              });
              if (i + 1 < this.supplyData.targeting.targetingSizes.list.length) {
                targeting.sizes_ui += '|';
              }
            }
            if (i + 1 < this.supplyData.targeting.targetingSizes.list.length) {
              targeting.sizes += ',';
            }
          }
        }
        targeting.vast_domains = '';
        targeting.vast_domains_oper = 0;
        if (this.targeting.vastDomains) {
          targeting.vast_domains_oper = this.supplyData.targeting.vast_domains.type;
          targeting.vast_domains = this.supplyData.targeting.vast_domains.list
            .map((dma) => {
              return dma.dma_id;
            })
            .join(',');
        }
        // DMA
        if (this.targeting.dma) {
          targeting.dma_oper = this.supplyData.targeting.dma.type;
          targeting.dma = this.supplyData.targeting.dma.list
            .map((dma) => {
              return dma.dma_id;
            })
            .join(',');
        } else {
          targeting.dma_oper = 0;
          targeting.dma = '';
        }
        // STATES
        if (this.targeting.state) {
          targeting.state_oper = this.supplyData.targeting.state.type;
          targeting.state = this.supplyData.targeting.state.list
            .map((state) => {
              return state.iso;
            })
            .join(',');
        } else {
          targeting.state_oper = 0;
          targeting.state = '';
        }
        // Targeting entry ID
        if (this.supplyData.targeting.targeting_id) {
          targeting.targeting_id = this.supplyData.targeting.targeting_id;
        }
        supplyToSave.targeting = targeting;
      } else if ([1, 0].includes(this.supplyData.type)) {
        if (this.targeting.vastDomains && this.supplyData.targeting.vast_domains.list.length) {
          targeting.vast_domains_oper = this.supplyData.targeting.vast_domains.type;
          targeting.vast_domains = this.supplyData.targeting.vast_domains.list.join(',');
        } else {
          this.supplyData.targeting.vast_domains = this.supplyService.supplyModel.targeting.vast_domains;
          this.targeting.vastDomains = false;
        }
        supplyToSave.targeting = targeting;
      }
      // Tag
      supplyToSave.passback = this.supplyData.passback ? this.supplyData.passback : false;
      supplyToSave.passback_code = this.supplyData.passback
        ? JSON.stringify({ string: this.supplyData.passbackCode })
        : null;
      supplyToSave.passback_timeout = this.supplyData.passback ? this.supplyData.passbackTimeout : null;
      supplyToSave.tag_schema_selected = this.supplyData.supplyPartner.val;
      // Save the player
      this.isLoading = true;
      this.subscriptions.push(
        this.httpService.post('vdsp_ws/saveSupply', supplyToSave).subscribe((response: any) => {
          if (response) {
            if (response.status.toLowerCase() === 'ok') {
              this.supplyData.playerId = response.playerId;
              this.userService.networkData.active_supplies_limit_reached = response.limit_reached;
              if (this.supplyData.type === 0 || this.supplyData.type === 1) {
                if (this.supplyData.type === 0 && this.supplyData.sub_type !== 0) {
                  this.saveContentUnit();
                } else {
                  if (this.allowedTag) {
                    this.saveTag(close);
                  }
                }
              } else {
                this.onSaveSuccess(close);
                if (close) {
                  this.close();
                }
              }
            } else if (response.errors && _.isObject(response.errors) && response.errors['active_supplies_limit']) {
              this.isLoading = false;
              this.sharedService.modalCedatoState = true;
              this.sharedService.modalCedatoHeader = 'WARNING';
              this.sharedService.modalCedatoBody = this.dictionaryService.get('LIMITS_NO_SAVE_MSG')('Supply');
              this.sharedService.modalCedatoButton = 'OK';
            } else {
              this.onSaveError(response.errors);
            }
          } else {
            this.onSaveError(response.errors);
          }
        })
      );
    }
    return noErrors;
  }

  saveContentUnit() {
    const params: any = {
      playerId: this.supplyData.playerId.toString(),
      tag_type_id: this.tagData.tag_type_id.toString(),
      tag_code: this.tagData.tag_code,
      ad_manager: this.tagData.ad_manager,
      safe_frame: this.tagData.safe_frame,
      config: JSON.stringify(this.tagData.config),
    };
    this.httpService.post('tag_schema/saveContentUnitTag', params).subscribe(
      (response: any) => {
        if (response.code === 500) {
          this.onSaveError(response.message);
        } else if (response == 'ok') {
          this.onSaveSuccess();
        } else {
          this.onSaveError();
        }
      },
      (error) => {
        this.onSaveError(error);
      }
    );
  }

  saveTag(close: boolean = false) {
    const params: any = {
      playerId: this.supplyData.playerId.toString(),
      tag_type: this.supplyData.tagType.toString(),
      domain: this.supplyData.domain,
      secure: this.supplyData.secure ? '1' : '0',
      mobileApp: this.supplyData.mobileApp ? '1' : '0',
      servingDomain: this.supplyData.networkDomainName ? this.supplyData.networkDomainName.domain : '',
      size_type: this.supplyData.sizeType.toString(),
      width:
        this.sharedService.isEmpty(this.supplyData.width) || this.supplyData.width < 1
          ? this.supplyService.supplyModel.width
          : this.supplyData.width.toString(),
      height:
        this.sharedService.isEmpty(this.supplyData.height) || this.supplyData.height < 1
          ? this.supplyService.supplyModel.height
          : this.supplyData.height.toString(),
      ratio:
        this.sharedService.isEmpty(this.supplyData.ratio) || this.supplyData.ratio < 1
          ? this.supplyService.supplyModel.ratio
          : this.supplyData.ratio.toString(),
      close_button: this.supplyData.closeButton ? '1' : '0',
      sound_on_hover: this.supplyData.soundOnHover ? '1' : '0',
      pause_on_hidden_tab: this.supplyData.pauseOnHiddenTab ? '1' : '0',
      close_on_ad_end: this.supplyData.closeOnAdEnd ? '1' : '0',
      close_on_content_end: this.supplyData.closeOnContentEnd ? '1' : '0',
      pause_on_visibility:
        this.sharedService.isEmpty(this.supplyData.pauseOnVisibility) ||
        this.supplyData.pauseOnVisibility < 1 ||
        this.supplyData.pauseOnVisibility > 100
          ? this.supplyService.supplyModel.pauseOnVisibility
          : this.supplyData.pauseOnVisibility.toString(),
      play_on_visibility: this.sharedService.isEmpty(this.supplyData.playOnVisibility)
        ? this.supplyService.supplyModel.playOnVisibility
        : this.supplyData.playOnVisibility <= this.supplyData.pauseOnVisibility
        ? this.supplyService.supplyModel.playOnVisibility
        : this.supplyData.playOnVisibility.toString(),
      box_height:
        this.sharedService.isEmpty(this.supplyData.boxHeight) || this.supplyData.boxHeight < 1
          ? this.supplyService.supplyModel.boxHeight
          : this.supplyData.boxHeight.toString(),
      box_color: this.sharedService.isEmpty(this.supplyData.boxColor)
        ? this.supplyService.supplyModel.boxColor
        : this.supplyData.boxColor.toString(),
      persistent_width:
        this.sharedService.isEmpty(this.supplyData.persistentWidth) || this.supplyData.persistentWidth < 1
          ? this.supplyService.supplyModel.persistentWidth
          : this.supplyData.persistentWidth.toString(),
      persistent_height:
        this.sharedService.isEmpty(this.supplyData.persistentHeight) || this.supplyData.persistentHeight < 1
          ? this.supplyService.supplyModel.persistentHeight
          : this.supplyData.persistentHeight.toString(),
      persistent_location_y_px:
        this.sharedService.isEmpty(this.supplyData.persistentLocationYPx) || this.supplyData.persistentLocationYPx < 1
          ? this.supplyService.supplyModel.persistentLocationYPx
          : this.supplyData.persistentLocationYPx.toString(),
      persistent_location_y_from: this.sharedService.isEmpty(this.supplyData.persistentLocationYFrom)
        ? this.supplyService.supplyModel.persistentLocationYFrom
        : this.supplyData.persistentLocationYFrom,
      persistent_location_x_px:
        this.sharedService.isEmpty(this.supplyData.persistentLocationXPx) || this.supplyData.persistentLocationXPx < 1
          ? this.supplyService.supplyModel.persistentLocationXPx
          : this.supplyData.persistentLocationXPx.toString(),
      persistent_location_x_from: this.sharedService.isEmpty(this.supplyData.persistentLocationXFrom)
        ? this.supplyService.supplyModel.persistentLocationXFrom
        : this.supplyData.persistentLocationXFrom,
      persistent_padding:
        this.sharedService.isEmpty(this.supplyData.persistentPadding) || this.supplyData.persistentPadding < 1
          ? this.supplyService.supplyModel.persistentPadding
          : this.supplyData.persistentPadding.toString(),
    };
    if ((this.supplyData.tagType === 7 || this.supplyData.tagType === 8) && this.supplyData.sizeType === 0) {
      params.width = this.supplyData.cornerWidth.toString();
    }
    const originalPlayerTag: any =
      this.getSupplyResponse && this.getSupplyResponse.tag_data
        ? _.omit(_.cloneDeep(this.getSupplyResponse.tag_data), 'supply_tag_id')
        : {};
    if (
      !_.isEqual(originalPlayerTag, params) ||
      !_.find(this.supplyData.tagSchemas, { partnerId: this.supplyData.supplyPartner.val.toString() })
    ) {
      this.httpService.post('tag_schema/saveSupplyTag', params).subscribe(
        () => {
          if (
            this.supplyData.tagType === 0 ||
            !_.find(this.supplyData.tagSchemas, { partnerId: this.supplyData.supplyPartner.val.toString() })
          ) {
            this.saveOldTag(close);
          } else {
            this.onSaveSuccess(close);
          }
        },
        () => {
          this.sharedService.showErrorFlashMessage();
        }
      );
    } else {
      this.onSaveSuccess(close);
    }

    this.isLoading = false;
  }

  saveOldTag(close: boolean = false) {
    let schema: any = _.find(this.supplyData.tagSchemas, { partnerId: this.supplyData.supplyPartner.val.toString() });
    if (this.duplicateMode) {
      schema = undefined;
    }
    const url: string = schema === undefined ? 'tag_schema/saveSchema' : 'tag_schema/updateSchema';
    const params: any = {
      playerId: this.supplyData.playerId,
      partnerId: +this.supplyData.supplyPartner.val,
      tagSchema: JSON.stringify({
        tagSizeSelected: this.supplyData.playerSize,
        vpaidTypeSelected: { name: 'VPAID', val: '' },
        tagSize: {
          width: this.supplyData.width,
          height: this.supplyData.height,
        },
        tagSecure: this.supplyData.secure,
        tagMobileApp: this.supplyData.mobileApp,
        tagSubId: this.supplyData.subId,
        tag_domain_selected: this.supplyData.networkDomainName,
      }),
    };
    if (schema) {
      params.schemaId = +schema.id;
    }
    this.httpService.post(url, params).subscribe(
      () => {
        this.onSaveSuccess(close);
      },
      () => {
        this.sharedService.showErrorFlashMessage();
        this.isLoading = false;
      }
    );
  }

  close() {
    this.router.navigate(['/supply/manage']).then(() => {
      return;
    });
  }

  saveAndExit() {
    this.save(true);
  }

  onSaveSuccess(close: boolean = false) {
    if (this.editMode && !this.duplicateMode) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('SUPPLY_SAVED_SUCCESSFULLY'), 'success');
      if (!close) {
        this.initializeSupplyData();
      }
      this.sharedService.sendMessage('SUPPLY_SAVED_SUCCESSFULLY');
      if (this.newPartner) {
        this.sharedService.sendMessage('NEW_SUPPLY_PARTNER');
        this.subscriptions.push(
          this.sharedService.getMessagesBus().subscribe((response: any) => {
            if (response.type === 'SUPPLY_PARTNERS_UPDATED') {
              this.resetPartners();
              this.isLoading = false;
            }
          })
        );
      } else {
        this.isLoading = false;
      }
    } else {
      this.sharedService.showFlashMessage(this.dictionaryService.get('SUPPLY_CREATED_SUCCESSFULLY'), 'success');
      if (this.supplyData.type === 2) {
        this.router.navigate(['/supply/manage/', this.supplyData.playerId]).then(() => {
          return;
        });
      } else {
        this.router
          .navigate(['/supply/manage/', this.supplyData.playerId], { queryParams: { tag: 'true' } })
          .then(() => {
            return;
          });
      }
    }
    this.originalData = _.cloneDeep(this.supplyData);
    if (close) {
      this.close();
    }
  }

  onSaveError(errors: any = {}) {
    this.sharedService.flashMessages = [];
    this.sharedService.flashMessagesIndex = 0;
    this.sharedService.showErrorFlashMessage(errors);
    this.isLoading = false;
  }

  targetingTogglerChange(type: string) {
    this.targeting[type] = !this.targeting[type];
    if (this.targeting[type] === false) {
      this.supplyData.targeting[type].type = 0;
      this.supplyData.targeting[type].list = [];
    }

    if (['state', 'dma'].includes(type)) {
      if (type === 'states') {
        this.targeting.dma = false;
        this.supplyData.targeting.dma.type = 0;
        this.supplyData.targeting.dma.list = [];
      } else if (type === 'dma') {
        this.targeting.state = false;
        this.supplyData.targeting.state.type = 0;
        this.supplyData.targeting.state.list = [];
      }
    }
  }

  initializeCampaigns(): Promise<void> {
    return new Promise((resolve) => {
      let currency = '';
      this.isLoadingCampaigns = true;
      this.getCampaigns().subscribe(
        (response: any) => {
          if (response.status.toLowerCase() === 'ok' && _.isArray(response.data)) {
            const data: Array<any> = [];
            for (let i = 0; i < response.data.length; i++) {
              currency = this.campaignsService.getCurrencyString(+response.data[i].b_c);
              data[i] = {};
              data[i].$$id = +response.data[i].b_i;
              data[i].$$active = !!+response.data[i].b_a;
              data[i].b_active = response.data[i].b_a;
              data[i].b_id = response.data[i].b_i;
              data[i].b_name = response.data[i].b_n;
              data[i].b_start = response.data[i].b_s;
              data[i].b_end = response.data[i].b_e;
              data[i].b_running = this.campaignsService.getRunningState(response.data[i])
                ? this.dictionaryService.get('IS_RUNNING')
                : this.dictionaryService.get('NOT_RUNNING');
              data[i].b_hourly =
                +response.data[i].b_i === 0
                  ? '–'
                  : currency +
                    this.sharedService.toLocaleString(this.campaignsService.parseFloat(response.data[i].b_h));
              data[i].b_daily =
                +response.data[i].b_d === 0
                  ? '–'
                  : currency +
                    this.sharedService.toLocaleString(this.campaignsService.parseFloat(response.data[i].b_d));

              data[i].$$link = `/campaigns/manage/${response.data[i].b_i}`;
            }
            this.assignedCampaignDataDisplayed = data;

            if (!data.length) {
              const campaignsSection: any = _.find(this.allSections, { name: 'ASSIGNED_CAMPAIGNS' });
              campaignsSection.toggleStatus = false;
            }
          } else {
            this.onError(true);
          }
        },
        () => {
          this.onError(false);
        }
      );

      this.isLoadingCampaigns = false;
      resolve();
    });
  }

  getCampaigns() {
    return this.httpService.post('budget_manager/getBudgetsByEntity', { id: this.routeParams.id, type: 2 });
  }

  onExtraParamToggleChange($event) {
    const extraParamsSectionItem: any = _.find(this.allSections, { value: 'extraParams' });
    if (!$event) {
      const parsed = this.parseExtraParams(this.supplyService.extraParamsDefaultValue.json);
      this.supplyData.extra_params = stringify(Object.assign({}, parsed, this.experimentalFeatures), {
        space: this.sharedService.formatJSONstring,
      });
      // this.supplyData.extra_params = stringify(JSON.parse(this.supplyService.extraParamsDefaultValue.json), { space: this.sharedService.formatJSONstring });
    }
    this.supplyData.extra_params_enabled = $event;
    if (extraParamsSectionItem) {
      extraParamsSectionItem.onIf = this.supplyData.extra_params_enabled;
    }
  }

  formatExtraParamsJSON() {
    let json = null;
    try {
      // tslint:disable-next-line: no-eval
      json = eval('(' + this.supplyData.extra_params + ')');
    } catch (e) {}
    if (this.validateExtraParamsJSON(json)) {
      setTimeout(() => {
        this.supplyData.extra_params = stringify(json, { space: this.sharedService.formatJSONstring });
      });
    }
  }

  @HostListener('document:wheel', ['$event'])
  onScroll() {
    let found = false;
    let index = 0;
    const scrollY: number = window.scrollY;
    const sections: HTMLElement = document.getElementById('sections');
    let currSection: HTMLElement;
    if (sections) {
      while (!found && index < this.visibleSections.length - 1) {
        currSection = document.getElementById(this.visibleSections[index].value);
        if (currSection) {
          found = currSection.offsetTop >= scrollY;
        }
        if (!found) {
          index++;
        }
      }
    }
    this.activeSection =
      document.scrollingElement.scrollHeight - document.scrollingElement.scrollTop ===
      document.scrollingElement.clientHeight
        ? _.findIndex(this.allSections, { value: this.visibleSections[this.visibleSections.length - 1].value })
        : _.findIndex(this.allSections, { value: this.visibleSections[index].value });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateTagPreview();
  }

  isCustomTemplate() {
    return this.tagData.config && this.tagData.config.template !== undefined;
  }

  tagDataConfigSetTemplate(template) {
    if (template) {
      this.tagData.config.template = template;
    } else {
      delete this.tagData.config.template;
    }

    this.onTagConfigUpdate();
  }

  parseExtraParams(paramsStr: string): object {
    try {
      return JSON.parse(paramsStr || '{}');
    } catch (error) {
      console.error('Could not parse extra params');
    }
  }

  updateExtraParams(params: object) {
    try {
      const parsed: any = this.parseExtraParams(this.supplyData.extra_params || '{}');

      this.supplyData.extra_params = stringify(Object.assign({}, parsed, params), {
        space: this.sharedService.formatJSONstring,
      });
    } catch (error) {
      console.error('Could not update extra params');
    }
  }

  getExperimentalFeatures(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr || this.supplyData.extra_params || '{}');

    Object.keys(this.experimentalFeatures).forEach((feature: string) => {
      this.experimentalFeatures[feature] = parsed[feature] || false;
    });
  }

  toggleExperimentalFeature(feature: string) {
    if (!this.supplyData.extra_params_enabled) {
      this.supplyData.extra_params_enabled = true;
    }

    this.experimentalFeatures[feature] = !this.experimentalFeatures[feature];

    this.updateExtraParams(this.experimentalFeatures);
  }


  /**
   * Determines whether the CTV (Condition to View) is met based on the type of supply data.
   * For type 0 (HTML), it checks if the user has admin privileges.
   * For types 1 (CedatoX) and 2 (VAST), it returns true.
   *
   * @return {boolean} Returns true if the conditions are met for the respective supplyData type, otherwise false.
   */
  showCTV() {
    if (this.supplyData.type === 0) {
      return this.userService.isAdmin();
    }

    return this.supplyData.type === 1 || this.supplyData.type === 2;
  }
}
